export default {
  "account": {
    "id": 1,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["account"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Account"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["account"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/settings/account/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "authenticationTextStep1": {
    "id": 2,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["authenticationTextStep1"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["1. Open your Authenticator app"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["authenticationTextStep1"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/settings/account/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "authenticationTextStep2": {
    "id": 3,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["authenticationTextStep2"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["2. Choose Add"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["authenticationTextStep2"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/settings/account/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "authenticationTextStep3": {
    "id": 4,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["authenticationTextStep3"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["3. Choose 'Scan barcode' option"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["authenticationTextStep3"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/settings/account/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "authenticationTextStep4": {
    "id": 5,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["authenticationTextStep4"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["4. Scan barcode"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["authenticationTextStep4"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/settings/account/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "authenticationTextStep5": {
    "id": 6,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["authenticationTextStep5"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["5. Enter code displayed in the authenticator"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["authenticationTextStep5"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/settings/account/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "authenticationTextStep6": {
    "id": 7,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["authenticationTextStep6"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["6. Click validate button"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["authenticationTextStep6"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/settings/account/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "takeTheFollowingSteps": {
    "id": 8,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["takeTheFollowingSteps"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["TAKE THE FOLLOWING STEPS :"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["takeTheFollowingSteps"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/settings/account/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "connectAuthenticator": {
    "id": 9,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["connectAuthenticator"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Connect Authenticator"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["connectAuthenticator"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/settings/account/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "authenticatorSmall": {
    "id": 10,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["authenticatorSmall"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authenticator"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["authenticatorSmall"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/settings/account/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "cancel": {
    "id": 11,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["cancel"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cancel"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["cancel"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "validate": {
    "id": 12,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["validate"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Validate"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["validate"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "documentUpperCase": {
    "id": 13,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["documentUpperCase"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DOCUMENT"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["documentUpperCase"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/settings/documentation/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "editAccount": {
    "id": 14,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["editAccount"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Edit Account"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["editAccount"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/settings/account/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "save": {
    "id": 15,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["save"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Save"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["save"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "stockExtractionMethods": {
    "id": 16,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["stockExtractionMethods"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Stock Extraction Methods"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["stockExtractionMethods"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/settings/account/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "stockExtractionMethodsText1": {
    "id": 17,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["stockExtractionMethodsText1"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Key extraction always requires an additional authentication step. It is preferable to activate authentication via an authenticator app (2FA), but can also be performed via an activation link that is send to the email address of the current user."])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["stockExtractionMethodsText1"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/settings/account/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "stockExtractionMethodsText2": {
    "id": 18,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["stockExtractionMethodsText2"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Please note that when 'Via email link' is selected, VaultN cannot take any responsibility of the assets anymore."])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["stockExtractionMethodsText2"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/settings/account/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "stockExtractionLowerCase": {
    "id": 19,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["stockExtractionLowerCase"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Stock Extraction"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["stockExtractionLowerCase"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/settings/account/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "uploadDocumentLowerCase": {
    "id": 20,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["uploadDocumentLowerCase"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Upload Document"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["uploadDocumentLowerCase"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/settings/documentation/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "uploadNewImage": {
    "id": 21,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["uploadNewImage"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Upload new image"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["uploadNewImage"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/products-add/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "users": {
    "id": 22,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["users"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Users"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["users"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/settings/account/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "stockExtraction": {
    "id": 23,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["stockExtraction"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Stock extraction"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["stockExtraction"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/settings/account/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "lastLogin": {
    "id": 24,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["lastLogin"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Last Login"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["lastLogin"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/settings/account/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "ownerRole": {
    "id": 25,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ownerRole"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Owner Role"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ownerRole"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/settings/account/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "userRole": {
    "id": 26,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["userRole"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["User Role"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["userRole"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/settings/account/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "authenticatorConnected": {
    "id": 26,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["authenticatorConnected"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["App connected! Check your email."])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["authenticatorConnected"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/settings/account/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "displaying": {
    "id": 27,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["displaying"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Displaying"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["displaying"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/settings/api-insights/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "duration": {
    "id": 28,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["duration"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["duration"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["duration"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/settings/api-insights/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "headersLowerCase": {
    "id": 29,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["headersLowerCase"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Headers"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["headersLowerCase"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/settings/api-insights/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "logEntries": {
    "id": 30,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["logEntries"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Log entries"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["logEntries"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/settings/api-insights/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "logs": {
    "id": 31,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["logs"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["logs"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["logs"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/settings/api-insights/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "requestsLowerCase": {
    "id": 32,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["requestLowerCase"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Requests"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["requestLowerCase"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/settings/api-insights/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "responseLowerCase": {
    "id": 33,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["responseLowerCase"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Response"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["responseLowerCase"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/settings/api-insights/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "serviceUrl": {
    "id": 34,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["serviceUrl"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Service url"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["serviceUrl"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/settings/api-insights/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "timeStamp": {
    "id": 35,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["timeStamp"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Time Stamp"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["timeStamp"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/settings/api-insights/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "addCertificateUpperCase": {
    "id": 36,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["addCertificateUpperCase"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ADD CERTIFICATE"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["addCertificateUpperCase"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/settings/certificate/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "addCertificateLowerCase": {
    "id": 37,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["addCertificateLowerCase"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Add Certificate"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["addCertificateLowerCase"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/settings/certificate/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "upload": {
    "id": 38,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["upload"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Upload"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["upload"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/settings/certificate/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "mustBeCrtCerFiles": {
    "id": 39,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["mustBeCrtCerFiles"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Selected files must be .crt or .cer file"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["mustBeCrtCerFiles"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/settings/certificate/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "selectCrtFileText1": {
    "id": 40,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["selectCrtFileText1"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Select a .CER or .CRT file on your device to upload and install a certificate."])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["selectCrtFileText1"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/settings/certificate/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "selectCrtFileText2": {
    "id": 41,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["selectCrtFileText2"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Make sure that the selected file meets the requirements"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["selectCrtFileText2"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/settings/certificate/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "stockAdded": {
    "id": 42,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["stockAdded"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["You will being updated via your inbox when the batch is fully processed."])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["stockAdded"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/settings/certificate/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "agreementUpperCase": {
    "id": 43,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["agreementUpperCase"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["RIGHT"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["agreementUpperCase"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/assets/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "agreements": {
    "id": 44,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["agreements"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Agreements"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["agreements"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/assets/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "agreementLowerCase": {
    "id": 45,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["agreementLowerCase"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Right"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["agreementLowerCase"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/assets/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "discontinue": {
    "id": 46,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["discontinue"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Discontinue"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["discontinue"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/assets/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "active": {
    "id": 47,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["active"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Active"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["active"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/assets/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "archive": {
    "id": 48,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["archive"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Archive"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["archive"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/transaction/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "available": {
    "id": 49,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["available"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Available"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["available"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/assets/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "blacklisted": {
    "id": 50,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["blacklisted"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Blacklisted"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["blacklisted"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/transaction/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "chain": {
    "id": 51,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chain"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Chain"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chain"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/transaction/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "extracted": {
    "id": 52,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["extracted"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Extracted"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["extracted"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/transaction/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "graph": {
    "id": 53,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["graph"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Graph"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["graph"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/transaction/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "inserted": {
    "id": 54,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["inserted"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Inserted"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["inserted"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/transaction/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "me": {
    "id": 55,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["me"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Me"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["me"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/transaction/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "received": {
    "id": 56,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["received"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Received"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["received"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/transaction/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "transferred": {
    "id": 57,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["transferred"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Transferred"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["transferred"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/transaction/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "product": {
    "id": 58,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["product"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Product"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["product"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/assets/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "assets": {
    "id": 59,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["assets"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Assets"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["assets"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/assets/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "stockPoolLabel": {
    "id": 60,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["stockPool"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Stockpool"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["stockPool"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/assets/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "close": {
    "id": 61,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["close"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Close"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["close"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/assets/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "addCertificate": {
    "id": 62,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["addCertificate"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Add Certificate"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["addCertificate"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/settings/certificate/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "addUser": {
    "id": 63,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["addUser"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Add User"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["addUser"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/settings/users/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "addWebhook": {
    "id": 64,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["addWebhook"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Add Webhook"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["addWebhook"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/settings/users/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "filterApply": {
    "id": 65,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["filterApply"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Apply"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["filterApply"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/settings/assets/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "filterCancel": {
    "id": 66,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["filterCancel"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cancel"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["filterCancel"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/settings/assets/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "clear": {
    "id": 67,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["clear"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Clear"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["clear"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/settings/transaction/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "createReport": {
    "id": 68,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["createReport"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Create Report"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["createReport"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/settings/assets/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "exportGoogleSheet": {
    "id": 69,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["exportGoogleSheet"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Export this list to Google Sheets"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["exportGoogleSheet"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/settings/assets/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "exportListToGoogleSheets": {
    "id": 70,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["exportListToGoogleSheets"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Export Google Sheets"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["exportListToGoogleSheets"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/settings/assets/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "extract": {
    "id": 71,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["extract"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Extract"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["extract"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/settings/transaction/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "filter": {
    "id": 72,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["filter"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Filter"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["filter"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/settings/transaction/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "filters": {
    "id": 73,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["filters"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Filters"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["filters"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/settings/assets/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "insert": {
    "id": 74,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["insert"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Insert"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["insert"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/settings/assets/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "transfer": {
    "id": 75,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["transfer"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Transfer"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["transfer"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/settings/transaction/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "viewGoogleSheet": {
    "id": 76,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["viewGoogleSheet"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["View this list in Google Sheets"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["viewGoogleSheet"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/settings/assets/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "viewListGoogleSheets": {
    "id": 77,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["viewListGoogleSheets"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["View Google Sheets"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["viewListGoogleSheets"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/settings/assets/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "addConnection": {
    "id": 78,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["addConnection"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Add Connection"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["addConnection"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/home/dashboard/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "loading": {
    "id": 79,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["loading"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["loading..."])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["loading"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/transaction/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "areYouSure": {
    "id": 80,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["areYouSure"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Are you sure you want to perform this action?"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["areYouSure"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/finance/promotions/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "atRow": {
    "id": 81,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["atRow"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([" at row "])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["atRow"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/finance/price-lists/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "platformDRM": {
    "id": 82,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["platformDRM"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Platform (DRM)"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["platformDRM"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/assets/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "dateFrom": {
    "id": 83,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["dateFrom"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Start Date"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["dateFrom"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/assets/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "dateTill": {
    "id": 84,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["dateTill"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["End Date"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["dateTill"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/assets/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "dateWarn": {
    "id": 85,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["dateWarn"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["has not been selected."])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["dateWarn"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/assets/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "filterOptions": {
    "id": 86,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["filterOptions"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Filter Options"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["filterOptions"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/assets/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "moreFilters": {
    "id": 87,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["moreFilters"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["More Filters"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["moreFilters"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/assets/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "name": {
    "id": 88,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["name"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Name"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["name"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/settings/account/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "role": {
    "id": 89,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["role"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Role"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["role"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/settings/account/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "mfaEnabled": {
    "id": 90,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["mfaEnabled"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["MFA Enabled"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["mfaEnabled"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/settings/account/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "emailNotifications": {
    "id": 91,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["emailNotifications"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Email notifications"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["emailNotifications"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/settings/account/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "isActive": {
    "id": 92,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["isActive"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Active"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["isActive"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/settings/account/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "vaultnName": {
    "id": 93,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["vaultnName"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["VaultN"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["vaultnName"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/settings/account/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "email": {
    "id": 94,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["email"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Email"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["email"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/settings/account/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "vaultnGuid": {
    "id": 95,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["vaultnGuid"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["VaultN GUID"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["vaultnGuid"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/settings/account/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "companyName": {
    "id": 96,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["companyName"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Company"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["companyName"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/settings/account/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "defaultCurrency": {
    "id": 97,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["defaultCurrency"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Default currency"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["defaultCurrency"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/settings/account/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "defaultPriceList": {
    "id": 98,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["defaultPriceList"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Default pricelist"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["defaultPriceList"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/settings/account/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "country": {
    "id": 99,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["country"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Country"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["country"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/settings/account/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "timezone": {
    "id": 100,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["timezone"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Timezone"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["timezone"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/settings/account/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "accountUpdated": {
    "id": 101,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["accountUpdated"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Account Updated"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["accountUpdated"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/settings/account/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "delete": {
    "id": 102,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["delete"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Delete"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["delete"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/assets/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "detail": {
    "id": 103,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["detail"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Detail"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["detail"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/assets/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "download": {
    "id": 104,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["download"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Download"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["download"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/assets/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "edit": {
    "id": 105,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["edit"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Edit"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["edit"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/assets/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "ErrorType500": {
    "id": 106,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ErrorType500"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Server encountered an unexpected error. Please try again."])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ErrorType500"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/assets/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "ErrorType404": {
    "id": 107,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ErrorType404"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No records found."])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ErrorType404"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/assets/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "ErrorType401": {
    "id": 108,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ErrorType401"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentication error. Please login"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ErrorType401"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/assets/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "noData": {
    "id": 109,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["noData"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No data available"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["noData"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/assets/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "of": {
    "id": 110,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["of"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([" of "])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["of"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/assets/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "priceListIsReadyToDownload": {
    "id": 111,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["priceListIsReadyToDownload"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Price list excel file is ready to download"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["priceListIsReadyToDownload"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/assets/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "reportIsReadyToDownload": {
    "id": 112,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["reportIsReadyToDownload"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Report is ready to download"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["reportIsReadyToDownload"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/finance/report-list/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "reportPrepared": {
    "id": 113,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["reportPrepared"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Report is being prepared. This might take a while..."])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["reportPrepared"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/finance/report-list/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "requestSuccess": {
    "id": 114,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["requestSuccess"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Request successful"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["requestSuccess"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/assets/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "search": {
    "id": 115,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["search"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Search"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["search"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/assets/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "tokenExpired": {
    "id": 116,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["tokenExpired"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentication expired"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["tokenExpired"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/assets/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "metaDataSaved": {
    "id": 117,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["metaDataSaved"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Metadata saved"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["metaDataSaved"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/assets/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "productSaved": {
    "id": 118,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["productSaved"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Product saved"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["productSaved"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/assets/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "productNotActive": {
    "id": 119,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["productNotActive"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Product is not connected. Actions are not allowed."])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["productNotActive"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/assets/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "priceListProductRowUpdate": {
    "id": 120,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["priceListProductRowUpdate"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Currently you are editing this region. The changes you make can't be undone after SAVING."])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["priceListProductRowUpdate"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/finance/price-lists/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "priceListAddCountry": {
    "id": 121,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["priceListAddCountry"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Currently you are adding new region. The changes you make can't be undone after SAVING."])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["priceListAddCountry"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/finance/price-lists/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "priceListProductRowDelete": {
    "id": 122,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["priceListProductRowDelete"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Currently you are deleting region. The changes you make can't be undone."])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["priceListProductRowDelete"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/finance/price-lists/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "alreadyAnAccount": {
    "id": 123,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["alreadyAnAccount"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Already a part of the VaultN community? Sign in here"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["alreadyAnAccount"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/create-account/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "company": {
    "id": 124,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["company"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Company"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["company"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/create-account/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "continueAndLogin": {
    "id": 126,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["continueAndLogin"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Continue and login"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["continueAndLogin"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/create-account/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "createANewVault": {
    "id": 127,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["createANewVault"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Create Your VaultN Account"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["createANewVault"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/create-account/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "next": {
    "id": 128,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["next"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Next"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["next"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/create-account/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "registrationInfoText": {
    "id": 129,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["registrationInfoText"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["We have sent you an email to complete your registration"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["registrationInfoText"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/create-account/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "thankYouForYourRegistration1": {
    "id": 130,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["thankYouForYourRegistration1"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Thank you"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["thankYouForYourRegistration1"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/create-account/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "thankYouForYourRegistration2": {
    "id": 131,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["thankYouForYourRegistration2"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["for your registration"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["thankYouForYourRegistration2"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/create-account/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "vaultNName": {
    "id": 132,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["vaultNName"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["VaultN Name"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["vaultNName"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/create-account/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "welcomeToVaultN": {
    "id": 133,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["welcomeToVaultN"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Welcome to VaultN! Start your journey towards smarter distribution."])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["welcomeToVaultN"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/create-account/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "results": {
    "id": 134,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["results"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["results"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["results"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/assets/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "Inbox": {
    "id": 135,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Inbox"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Inbox"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Inbox"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/inbox/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "Outbox": {
    "id": 136,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Outbox"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Outbox"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Outbox"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/outbox/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "stockPoolIn": {
    "id": 137,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["stockPoolIn"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["In"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["stockPoolIn"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/stockpool-in/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "stockPoolOut": {
    "id": 138,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["stockPoolOut"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Out"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["stockPoolOut"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/stockpool-out/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "apply": {
    "id": 139,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["apply"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Apply"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["apply"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/home/dashboard/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "fromDate": {
    "id": 140,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["fromDate"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["From"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["fromDate"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/home/dashboard/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "toDate": {
    "id": 141,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["toDate"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["To"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["toDate"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/home/dashboard/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "addNewArticle": {
    "id": 142,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["addNewArticle"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Add New Article"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["addNewArticle"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/settings/documentation/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "editDocumentation": {
    "id": 143,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["editDocumentation"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Edit Documentation"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["editDocumentation"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/settings/documentation/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "checkEmail": {
    "id": 144,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["checkEmail"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Check email"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["checkEmail"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/assets/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "clickButtonToStartDownload": {
    "id": 145,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["clickButtonToStartDownload"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Click the button below to start your file download"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["clickButtonToStartDownload"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/assets/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "extractAssets": {
    "id": 146,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["extractAssets"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["EXTRACT INVENTORY"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["extractAssets"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/assets/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "extracting": {
    "id": 147,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["extracting"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["EXTRACTING..."])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["extracting"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/assets/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "fillCodeDisplayed": {
    "id": 148,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["fillCodeDisplayed"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Please fill in the code displayed in your connected Authenticator app"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["fillCodeDisplayed"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/assets/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "isAgreed": {
    "id": 149,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["isAgreed"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Please confirm this extraction is final and cannot be undone"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["isAgreed"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/assets/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "noAuthenticatorConnected": {
    "id": 150,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["noAuthenticatorConnected"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No Authenticator connected yet? Go to your account settings to connect your Authenticator to your account"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["noAuthenticatorConnected"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/assets/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "noPlatforms": {
    "id": 151,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["noPlatforms"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["You have no Platform (DRM)s related to that right"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["noPlatforms"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/assets/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "noStock": {
    "id": 152,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["noStock"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["You have no stock for this product and this Platform (DRM)"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["noStock"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/assets/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "platform": {
    "id": 153,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["platform"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Platform"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["platform"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/assets/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "quantity": {
    "id": 154,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["quantity"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Quantity"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["quantity"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/assets/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "receivedInformation": {
    "id": 155,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["receivedInformation"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["You have received an email containing information on how to download your assets"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["receivedInformation"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/assets/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "receivedSerials": {
    "id": 156,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["receivedSerials"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["You will receive an email containing information on how to download your serials"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["receivedSerials"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/assets/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "region": {
    "id": 157,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["region"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Region"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["region"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/assets/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "rights": {
    "id": 158,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["rights"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rights"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["rights"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/assets/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "selectProduct": {
    "id": 159,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["selectProduct"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Select Product"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["selectProduct"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/assets/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "sendAuthCodeToEmail": {
    "id": 160,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["sendAuthCodeToEmail"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Send me the 6-digit confirmation code to my e-mail instead"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["sendAuthCodeToEmail"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/assets/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "authCodeSentEmail": {
    "id": 161,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["authCodeSentEmail"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentication code is sent. Please check your email"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["authCodeSentEmail"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/assets/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "edition": {
    "id": 162,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["edition"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Edition"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["edition"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/assets/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "publisher": {
    "id": 163,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["publisher"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Publisher"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["publisher"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/assets/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "extractionIsFinalCannotBeDone": {
    "id": 164,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["extractionIsFinalCannotBeDone"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["I understand that this extraction is final and cannot be undone"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["extractionIsFinalCannotBeDone"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/assets/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "pleaseCheckAuthenticator": {
    "id": 165,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["pleaseCheckAuthenticator"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Please check authenticator code"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["pleaseCheckAuthenticator"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/assets/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "myProfile": {
    "id": 166,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["myProfile"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["My Profile"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["myProfile"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/settings/account/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "signOut": {
    "id": 167,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["signOut"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sign out"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["signOut"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/settings/account/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "dolar": {
    "id": 168,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["dolar"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["USD"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["dolar"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/home/dashboard/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "dolarSign": {
    "id": 169,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["dolarSign"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["$"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["dolarSign"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/home/dashboard/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "euro": {
    "id": 170,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["euro"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["EUR"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["euro"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/home/dashboard/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "euroSign": {
    "id": 171,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["euroSign"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["€"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["euroSign"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/home/dashboard/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "myCurrency": {
    "id": 172,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["myCurrency"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["My Currency"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["myCurrency"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/home/dashboard/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "welcome": {
    "id": 173,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["welcome"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Welcome to VaultN,"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["welcome"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/home/dashboard/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "createNewSku": {
    "id": 174,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["createNewSku"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Create New SKU"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["createNewSku"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/assets/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "createSku": {
    "id": 175,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["createSku"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["CREATE SKU"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["createSku"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/assets/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "createNewSkuUppercase": {
    "id": 176,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["createNewSkuUppercase"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["CREATE NEW SKU"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["createNewSkuUppercase"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/assets/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "confirmation": {
    "id": 177,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["confirmation"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confirmation"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["confirmation"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/assets/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "skuUppercase": {
    "id": 178,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["skuUppercase"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SKU"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["skuUppercase"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/assets/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "addMoreSku": {
    "id": 179,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["addMoreSku"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Add more SKU"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["addMoreSku"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/assets/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "create": {
    "id": 180,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["create"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Create"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["create"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/assets/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "skuCreated": {
    "id": 181,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["skuCreated"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SKU Created"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["skuCreated"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/assets/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "created": {
    "id": 182,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["created"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([" created."])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["created"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/assets/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "settingsBtn": {
    "id": 183,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["settingsBtn"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Settings"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["settingsBtn"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/assets/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "uploads": {
    "id": 184,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["uploads"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uploads"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["uploads"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/assets/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "assetsInserted": {
    "id": 185,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["assetsInserted"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Assets are being inserted. This might take a while..."])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["assetsInserted"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/assets/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "statusCanceled": {
    "id": 186,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["statusCanceled"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Status canceled"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["statusCanceled"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/uploads/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "authenticateLabel": {
    "id": 187,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["authenticate"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authenticate"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["authenticate"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/assets/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "stockRepositoryUrl": {
    "id": 188,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["stockRepositoryUrl"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Stock Repository URL"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["stockRepositoryUrl"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/assets/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "priceRepositoryUrl": {
    "id": 189,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["priceRepositoryUrl"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Price Repository URL"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["priceRepositoryUrl"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/assets/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "transactionRepositoryUrl": {
    "id": 190,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["transactionRepositoryUrl"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Transaction Repository URL"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["transactionRepositoryUrl"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/assets/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "jwtSecret": {
    "id": 191,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["jwtSecret"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["JWT Secret"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["jwtSecret"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/assets/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "endpointUrl": {
    "id": 192,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["endpointUrl"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Endpoint URL"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["endpointUrl"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/settings/webhooks/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "type": {
    "id": 193,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["type"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Type"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["type"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/settings/webhooks/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "addWbhook": {
    "id": 194,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["addWbhook"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Add Webhook"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["addWbhook"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/settings/webhooks/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "updateWebhook": {
    "id": 195,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["updateWebhook"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Update Webhook"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["updateWebhook"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/settings/webhooks/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "uploadDetails": {
    "id": 196,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["uploadDetails"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Upload Details"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["uploadDetails"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/upload-detail/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "currency": {
    "id": 197,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["currency"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Currency"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["currency"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/assets/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "market": {
    "id": 198,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["market"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Market"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["market"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/assets/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "included": {
    "id": 199,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["included"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Included"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["included"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/assets/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "includedCheckbox": {
    "id": 200,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["includedCheckbox"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Exclude this country currency"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["includedCheckbox"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/assets/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "skuLabel": {
    "id": 201,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["skuLabel"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SKU"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["skuLabel"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/assets/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "inActive": {
    "id": 202,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["inActive"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Inactive"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["inActive"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/assets/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "downloadErrorKeys": {
    "id": 203,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["downloadErrorKeys"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Download Error Keys"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["downloadErrorKeys"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/uploads-detail/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "period": {
    "id": 204,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["period"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Period"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["period"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/assets/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "vault": {
    "id": 205,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["vault"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vault"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["vault"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/assets/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "clearAll": {
    "id": 206,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["clearAll"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Clear All"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["clearAll"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/assets/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "date": {
    "id": 207,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["date"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Date"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["date"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/assets/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "copy": {
    "id": 208,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["copy"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Copy"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["copy"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/assets/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "productOrSku": {
    "id": 209,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["productOrSku"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Product Name or SKU"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["productOrSku"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/assets/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "unitPrice": {
    "id": 210,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["unitPrice"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Unit Price"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["unitPrice"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/assets/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "estimatedPrice": {
    "id": 211,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["estimatedPrice"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Estimated Price"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["estimatedPrice"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/assets/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "description": {
    "id": 212,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["description"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Description"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["description"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/assets/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "blacklisting": {
    "id": 213,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["blacklisting"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Blacklisting"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["blacklisting"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/assets/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "visibility": {
    "id": 214,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["visibility"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Visibility"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["visibility"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/assets/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "extraction": {
    "id": 215,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["extraction"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Extraction"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["extraction"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/assets/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "promotionNoSkusAvailable": {
    "id": 215,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["promotionNoSkusAvailable"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Product has no available SKUs!"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["promotionNoSkusAvailable"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/assets/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "productAdded": {
    "id": 216,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["productAdded"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Product added"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["productAdded"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/products-add/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "franchise": {
    "id": 217,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["franchise"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Franchise"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["franchise"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/products-add/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "noProductsCreated": {
    "id": 218,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["noProductsCreated"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["It seems no products have been created yet. To get started, please set up new products or check our"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["noProductsCreated"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/products/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "display": {
    "id": 219,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["display"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Display"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["display"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/products/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "productType": {
    "id": 220,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["productType"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Product Type"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["productType"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/products/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "productStatus": {
    "id": 221,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["productStatus"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Product Status"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["productStatus"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/products/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "connection": {
    "id": 222,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["connection"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Connection"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["connection"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/products/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "releaseState": {
    "id": 223,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["releaseState"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Release State"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["releaseState"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/products/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "developer": {
    "id": 224,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["developer"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Developer"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["developer"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/products/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "productGUID": {
    "id": 225,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["productGUID"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ProductGUID"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["productGUID"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/products-edit/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "productID": {
    "id": 226,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["productID"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ProductID"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["productID"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/products-edit/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "connected": {
    "id": 227,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["connected"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Connected"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["connected"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/products-edit/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "status": {
    "id": 228,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["status"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Status"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["status"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/products-edit/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "delistedDate": {
    "id": 229,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["delistedDate"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Scheduled Delist Date UTC"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["delistedDate"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/products-edit/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "featureNotAvailable": {
    "id": 230,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["featureNotAvailable"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hi. This feature is currently not available for your account. If you believe you need access, please reach out to our Client Success Team for assistance."])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["featureNotAvailable"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/products/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "documentation": {
    "id": 231,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["documentation"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Documentation"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["documentation"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/products/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "sharedProducts": {
    "id": 232,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["sharedProducts"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Shared Products"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["sharedProducts"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/products/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "createdProducts": {
    "id": 233,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["createdProducts"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Created Products"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["createdProducts"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/products/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "noProductsShared": {
    "id": 234,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["noProductsShared"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No products have been shared with you by your Connections yet. Once a product is shared, you'll see it listed here."])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["noProductsShared"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/products/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "noConnections": {
    "id": 235,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["noConnections"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["You don't have any connections to other VaultN accounts yet. To set up a new connection, please proceed to My Network and invite a new connection."])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["noConnections"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/products/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "pleaseSelectScheduledDelistDate": {
    "id": 236,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["pleaseSelectScheduledDelistDate"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Select Scheduled Delist Date"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["pleaseSelectScheduledDelistDate"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/products-edit/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "scheludedDelistedDateCannotBeBeforeCurrentDateandTime": {
    "id": 237,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["scheludedDelistedDateCannotBeBeforeCurrentDateandTime"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Scheluded delist date cannot be before current date and time"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["scheludedDelistedDateCannotBeBeforeCurrentDateandTime"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/products-edit/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "skuStatus": {
    "id": 238,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["skuStatus"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SKU status"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["skuStatus"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/products-edit/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "skuType": {
    "id": 239,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["skuType"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SKU type"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["skuType"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/products-edit/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "bundleContent": {
    "id": 240,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["bundleContent"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bundle Content"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["bundleContent"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/products-edit/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "selectSku": {
    "id": 241,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["selectSku"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Select SKU"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["selectSku"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/products-edit/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "addToBundleToTheList": {
    "id": 242,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["addToBundleToTheList"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ADD TO BUNDLE"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["addToBundleToTheList"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/products-edit/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "bundleSku": {
    "id": 243,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["bundleSku"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bundle SKU"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["bundleSku"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/products-edit/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "keyProvider": {
    "id": 244,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["keyProvider"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Key Provider"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["keyProvider"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/shared-assets/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "productCriterias": {
    "id": 245,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["productCriterias"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Product Criterias"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["productCriterias"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/create-rule/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "allProducts": {
    "id": 246,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["allProducts"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["All Products"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["allProducts"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/create-rule/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "inactiveProductsVisible": {
    "id": 247,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["inactiveProductsVisible"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Inactive Products Visible"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["inactiveProductsVisible"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/create-rule/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "productEdition": {
    "id": 248,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["productEdition"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Product Edition"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["productEdition"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/create-rule/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "skuCriterias": {
    "id": 249,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["skuCriterias"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SKU Criterias"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["skuCriterias"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/create-rule/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "provider": {
    "id": 250,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["provider"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Provider"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["provider"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/create-rule/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "createRules": {
    "id": 251,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["createRules"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Create Rules"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["createRules"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/create-rule/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "shareRules": {
    "id": 252,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["shareRules"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Share Rules"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["shareRules"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/share-rule/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "editionCriteria": {
    "id": 253,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["editionCriteria"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Edition Criteria"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["editionCriteria"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/create-rule/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "allSkus": {
    "id": 254,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["allSkus"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["All SKUs"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["allSkus"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/create-rule/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "providerCriteria": {
    "id": 255,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["providerCriteria"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Provider Criteria"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["providerCriteria"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/create-rule/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "regionCriteria": {
    "id": 256,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["regionCriteria"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Region Criteria"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["regionCriteria"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/create-rule/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "skuCriteria": {
    "id": 500,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["skuCriteria"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SKU Criteria"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["skuCriteria"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/create-rule/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "addSkuCriteria": {
    "id": 501,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["addSkuCriteria"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Add SKU Criteria"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["addSkuCriteria"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/create-rule/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "removeSkuCriteria": {
    "id": 502,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["removeSkuCriteria"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Remove SKU criteria"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["removeSkuCriteria"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/create-rule/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "andOperator": {
    "id": 503,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["andOperator"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["AND"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["andOperator"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/create-rule/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "orOperator": {
    "id": 504,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["orOperator"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["OR"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["orOperator"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/create-rule/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "skuCriteriaRequired": {
    "id": 506,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["skuCriteriaRequired"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Add at least one SKU criteria value or enable All SKUs"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["skuCriteriaRequired"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/create-rule/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "ruleCreated": {
    "id": 257,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ruleCreated"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rule Created"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ruleCreated"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/create-rule/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "byConnection": {
    "id": 258,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["byConnection"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["By Connection"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["byConnection"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/sharing/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "byProduct": {
    "id": 259,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["byProduct"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["By Product"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["byProduct"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/sharing/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "poundSign": {
    "id": 260,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["poundSign"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["£"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["poundSign"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/home/dashboard/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "fixedPeriod": {
    "id": 261,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["fixedPeriod"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fixed Period"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["fixedPeriod"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/home/dashboard/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "netRevenueUnitsSold": {
    "id": 262,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["netRevenueUnitsSold"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["netRevenueUnitsSold"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/home/dashboard/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "validPeriod": {
    "id": 263,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["validPeriod"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Please enter valid period. End Date must be greater than Start date"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["validPeriod"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/home/dashboard/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "keysType": {
    "id": 264,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["keysType"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Keys Type"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["keysType"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/home/dashboard/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "selectKeysType": {
    "id": 265,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["selectKeysType"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Select Type Of Keys"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["selectKeysType"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/home/dashboard/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "revokedKeys": {
    "id": 266,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["revokedKeys"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Revoked Keys"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["revokedKeys"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/home/dashboard/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "inventoryKeys": {
    "id": 267,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["inventoryKeys"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Inventory Keys"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["inventoryKeys"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/home/dashboard/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "noRevokedKeys": {
    "id": 268,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["noRevokedKeys"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["There are no unprocessed revoked keys to extract."])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["noRevokedKeys"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/home/dashboard/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "salesCountry": {
    "id": 269,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["salesCountry"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sales Country (IP-address/Request)"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["salesCountry"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/orders/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "grossSalesPrice": {
    "id": 270,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["grossSalesPrice"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gross Sales Price"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["grossSalesPrice"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/orders/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "invoiceCurrency": {
    "id": 271,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["invoiceCurrency"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Invoice Currency"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["invoiceCurrency"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/orders/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "orderId": {
    "id": 272,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["orderId"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Order ID"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["orderId"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/orders/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "clientOrderReference": {
    "id": 273,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["clientOrderReference"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Client Order Reference"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["clientOrderReference"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/orders/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "netSalesPrice": {
    "id": 274,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["netSalesPrice"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Net Sales Price"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["netSalesPrice"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/orders/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "currencyPair": {
    "id": 275,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["currencyPair"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Currency Pair"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["currencyPair"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/orders/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "orderStatus": {
    "id": 276,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["orderStatus"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Order Status"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["orderStatus"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/orders/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "clientCustomerReference": {
    "id": 277,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["clientCustomerReference"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Client Customer Reference"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["clientCustomerReference"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/orders/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "salesCurrency": {
    "id": 278,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["salesCurrency"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sales Currency"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["salesCurrency"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/orders/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "exchangeRate": {
    "id": 279,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["exchangeRate"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Exchange Rate"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["exchangeRate"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/orders/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "orderItem": {
    "id": 280,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["orderItem"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Order Item"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["orderItem"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/orders/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "pricingDetails": {
    "id": 281,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["pricingDetails"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pricing Details"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["pricingDetails"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/orders/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "priceListGUID": {
    "id": 282,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["priceListGUID"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pricing List GUID"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["priceListGUID"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/orders/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "priceListName": {
    "id": 283,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["priceListName"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Price List Name"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["priceListName"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/orders/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "SRP": {
    "id": 284,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SRP"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SRP"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SRP"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/orders/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "purchasePrice": {
    "id": 285,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["purchasePrice"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Purchase Price"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["purchasePrice"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/orders/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "businessModel": {
    "id": 286,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["businessModel"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Business Model"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["businessModel"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/orders/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "revShareSource": {
    "id": 287,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["revShareSource"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rev share % - Source"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["revShareSource"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/orders/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "revShareTarget": {
    "id": 288,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["revShareTarget"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rev share % - Target"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["revShareTarget"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/orders/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "promotionId": {
    "id": 289,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["promotionId"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Promotion ID"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["promotionId"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/orders/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "promotionName": {
    "id": 290,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["promotionName"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Promotion Name"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["promotionName"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/orders/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "discountedSRP": {
    "id": 291,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["discountedSRP"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Discounted SRP"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["discountedSRP"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/orders/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "discountedPurchasePrice": {
    "id": 292,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["discountedPurchasePrice"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Discounted Purchase Price"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["discountedPurchasePrice"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/orders/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "discountPercent": {
    "id": 293,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["discountPercent"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Discount %"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["discountPercent"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/orders/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "orderEvenHistory": {
    "id": 294,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["orderEvenHistory"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Order Event History"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["orderEvenHistory"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/orders/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "cancelOrder": {
    "id": 295,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["cancelOrder"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cancel Order"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["cancelOrder"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/orders/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "skuPlatform": {
    "id": 296,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["skuPlatform"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SKU Platform"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["skuPlatform"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/orders/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "fulfilmentOrderStatus": {
    "id": 297,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["fulfilmentOrderStatus"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fulfilment Order Status"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["fulfilmentOrderStatus"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/orders/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "orderType": {
    "id": 298,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["orderType"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Order Type"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["orderType"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/orders/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "createInventoryLevelReport": {
    "id": 299,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["createInventoryLevelReport"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["CREATE INVENTORY REPORT"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["createInventoryLevelReport"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/finance/report-list/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "skuProvider": {
    "id": 300,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["skuProvider"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SKU Provider"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["skuProvider"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/finance/price-lists/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "skuRegion": {
    "id": 301,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["skuRegion"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SKU Region"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["skuRegion"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/finance/price-lists/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "inventoryLevelReport": {
    "id": 302,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["inventoryLevelReport"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Inventory Level Report"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["inventoryLevelReport"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/finance/price-lists/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "confirmationCode": {
    "id": 303,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["confirmationCode"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confirmation Code"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["confirmationCode"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/assets/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "orderAcceptDate": {
    "id": 304,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["orderAcceptDate"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Order Accept Date UTC"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["orderAcceptDate"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/products-add/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "fulfillmentDate": {
    "id": 305,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["fulfillmentDate"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fulfillment Date UTC"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["fulfillmentDate"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/products-add/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "releaseDate": {
    "id": 306,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["releaseDate"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Release Date UTC"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["releaseDate"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/products-add/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "isEmbargoed": {
    "id": 307,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["isEmbargoed"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Embargoed product only visible to users that are allowed to view/edit embargoed products."])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["isEmbargoed"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/products-add/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "checkReports": {
    "id": 308,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["checkReports"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Check reports"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["checkReports"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/products-add/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "pleaseCheckReports": {
    "id": 309,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["pleaseCheckReports"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Your keys will be included in a report generated after confirming the extraction. You will receive an email once the report has been generated and you can find your key extraction reports on your Reports page."])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["pleaseCheckReports"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/products-add/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "youWillReceiveAnEmailCompleteRegistration": {
    "id": 310,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["youWillReceiveAnEmailCompleteRegistration"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["You will receive an email to complete registration."])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["youWillReceiveAnEmailCompleteRegistration"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_network/connections/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "youRejectedInvitation": {
    "id": 311,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["youRejectedInvitation"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["You rejected invitation."])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["youRejectedInvitation"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_network/connections/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "youAcceptedInvitation": {
    "id": 312,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["youAcceptedInvitation"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["You accepted invitation."])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["youAcceptedInvitation"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_network/connections/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "editRules": {
    "id": 313,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["editRules"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Edit Rule"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["editRules"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/edit-rule/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "connectionDetails": {
    "id": 314,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["connectionDetails"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Connection Details"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["connectionDetails"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/connection-details/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "connectionDetailsRules": {
    "id": 315,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["connectionDetailsRules"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rules:"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["connectionDetailsRules"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/connection-details/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "connectionDetailsSKUProvider": {
    "id": 316,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["connectionDetailsSKUProvider"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SKU - Provider:"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["connectionDetailsSKUProvider"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/connection-details/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "copyRules": {
    "id": 317,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["copyRules"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Copy Rule settings"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["copyRules"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/create-rule/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "productTag": {
    "id": 318,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["productTag"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Product Tag"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["productTag"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/create-rule/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "tagCriteria": {
    "id": 319,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["tagCriteria"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tag Criteria"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["tagCriteria"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/create-rule/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "tag": {
    "id": 320,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["tag"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tag"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["tag"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/create-rule/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "copyRulesFrom": {
    "id": 321,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["copyRulesFrom"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Copy from"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["copyRulesFrom"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/create-rule/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "copyRulesConfirmation": {
    "id": 322,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["copyRulesConfirmation"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confirmation"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["copyRulesConfirmation"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/create-rule/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "copyRulesConfirmationQuestion": {
    "id": 323,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["copyRulesConfirmationQuestion"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Do you want to include the exceptions in the rule for this connection?"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["copyRulesConfirmationQuestion"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/create-rule/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "allowedExceptions": {
    "id": 324,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["allowedExceptions"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Allowed Exceptions"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["allowedExceptions"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/edit-rule/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "deniedExceptions": {
    "id": 325,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["deniedExceptions"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Denied Exceptions"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["deniedExceptions"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/edit-rule/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "sharingRulesTitle": {
    "id": 326,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["sharingRulesTitle"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sharing Rules"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["sharingRulesTitle"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/share-rule/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "createRule": {
    "id": 327,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["createRule"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Create Rule"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["createRule"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/share-rule/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "createSharingRules": {
    "id": 328,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["createSharingRules"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Create Sharing Rule"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["createSharingRules"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/connection-details/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "sharingRulesBtn": {
    "id": 329,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["sharingRules"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sharing rules"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["sharingRules"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/connection-details/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "productDetails": {
    "id": 330,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["productDetails"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Product Details"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["productDetails"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/sharing-product-details/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "connectionDetailsProductRules": {
    "id": 331,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["connectionDetailsProductRules"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Product - Inactive products:"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["connectionDetailsProductRules"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/connection-details/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "ruleUpdated": {
    "id": 332,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ruleUpdated"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rule Updated"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ruleUpdated"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/create-rule/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "requiredField": {
    "id": 333,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["requiredField"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Required Field"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["requiredField"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/create-rule/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "viewOrderDetails": {
    "id": 334,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["viewOrderDetails"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["View Order Details"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["viewOrderDetails"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/create-rule/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "productRuleSharingUpdated": {
    "id": 335,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["productRuleSharingUpdate"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Product Rule Sharing Updated"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["productRuleSharingUpdate"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/connection-details/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "productEditionLabelField": {
    "id": 336,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["productEditionLabelField"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Product Edition: "])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["productEditionLabelField"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/connection-details/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "regionLabelField": {
    "id": 337,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["regionLabelField"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Region: "])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["regionLabelField"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/connection-details/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "isDLC": {
    "id": 338,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["isDLC"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Product is a DLC"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["isDLC"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/products-edit/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "isBaseGame": {
    "id": 339,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["isBaseGame"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Product is a Base Game"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["isBaseGame"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/products-edit/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "notSoldSeparately": {
    "id": 340,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["notSoldSeparately"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cannot be sold as standalone"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["notSoldSeparately"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/products-edit/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "isBundleProduct": {
    "id": 341,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["isBundleProduct"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Is a bundle product"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["isBundleProduct"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/products-edit/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "trailerLink": {
    "id": 342,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["trailerLink"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Trailer Link"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["trailerLink"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/products-edit/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "productImage": {
    "id": 343,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["productImage"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Product Image"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["productImage"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/products-edit/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "url": {
    "id": 344,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["url"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["URL"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["url"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/products-edit/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "english": {
    "id": 345,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["english"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["English"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["english"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/products-edit/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "french": {
    "id": 346,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["french"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["French"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["english"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/products-edit/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "spanish": {
    "id": 347,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["spanish"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Spanish"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["spanish"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/products-edit/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "italian": {
    "id": 348,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["italian"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Italian"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["italian"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/products-edit/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "maxTotalUploadSize": {
    "id": 349,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["maxTotalUploadSize"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Max total upload size (400k)"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["maxTotalUploadSize"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/products-edit/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "rejectedEntries": {
    "id": 350,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["rejectedEntries"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["file(s) did not pass validation constraints"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["rejectedEntries"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/products-edit/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "dragAndDrop": {
    "id": 351,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["dragAndDrop"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Drag and drop files or click + to select"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["dragAndDrop"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/products-edit/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "selectFiles": {
    "id": 352,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["selectFiles"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Select Files"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["selectFiles"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/products-edit/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "addMore": {
    "id": 353,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["addMore"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Add More"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["addMore"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/products-edit/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "webAssets": {
    "id": 354,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["webAssets"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Web Assets"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["webAssets"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/products-edit/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "screenShots": {
    "id": 355,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["screenShots"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Screenshots"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["screenShots"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/products-edit/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "productUpdated": {
    "id": 356,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["productUpdated"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Product Updated"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["productUpdated"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/products-edit/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "productInformation": {
    "id": 357,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["productInformation"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Product Information"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["productInformation"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/products-edit/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "productAssets": {
    "id": 358,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["productAssets"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Product Assets"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["productAssets"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/products-edit/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "productConfigAndRelations": {
    "id": 359,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["productConfigAndRelations"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Product Config & Relations"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["productConfigAndRelations"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/products-edit/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "SKUs": {
    "id": 360,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SKUs"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SKUs"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SKUs"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/products-edit/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "productSharing": {
    "id": 361,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["productSharing"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["product Sharing"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["productSharing"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/products-edit/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "externalReferences": {
    "id": 362,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["externalReferences"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["External References"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["externalReferences"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/products-edit/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "externalPlatformID": {
    "id": 363,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["externalPlatformID"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["External Platform ID"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["externalPlatformID"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/products-edit/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "langCode": {
    "id": 364,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["langCode"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lang Code"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["langCode"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/products-edit/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "betaTag": {
    "id": 364,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["betaTag"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["BETA"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["betaTag"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/orders/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "copyOrderActivationURL": {
    "id": 365,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["copyOrderActivationURL"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Copy Activation URL"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["copyOrderActivationURL"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/orders/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "copiedOrderActivationURL": {
    "id": 366,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["copiedOrderActivationURL"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activation URL is copied"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["copiedOrderActivationURL"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/orders/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "editSku": {
    "id": 369,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["editSku"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Edit SKU"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["editSku"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/assets/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "productInformationSaved": {
    "id": 370,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["productInformationSaved"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Product Information saved"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["productInformationSaved"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/orders/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "changeSkuStatusTitle": {
    "id": 371,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["changeSkuStatusTitle"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Change status of SKU"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["changeSkuStatusTitle"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/assets/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "changeSkuStatusConfirmation": {
    "id": 372,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["changeSkuStatusConfirmation"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Are you sure you want to set this SKU to Inactive?"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["changeSkuStatusConfirmation"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/assets/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "changeSkuStatusWarning": {
    "id": 373,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["changeSkuStatusWarning"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Warning"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["changeSkuStatusWarning"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/assets/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "changeSkuStatusWarningConfirmation": {
    "id": 374,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["changeSkuStatusWarningConfirmation"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["This SKU has uploaded keys. Are you sure you want to set this SKU to InActive?"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["changeSkuStatusWarningConfirmation"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/assets/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "changeSkuStatusBody": {
    "id": 375,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["changeSkuStatusBody"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["If inactive, Connections will not be able to place orders for this SKU, and it will be hidden from their API responses and UI-views."])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["changeSkuStatusBody"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/assets/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "changeSkuStatusWarningBody": {
    "id": 376,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["changeSkuStatusWarningBody"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Once inactive, Connections will not be able to place orders for this SKU, and it will be hidden from their API responses and UI-views."])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["changeSkuStatusWarningBody"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/assets/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "syncExternalMetaDataDone": {
    "id": 377,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["syncExternalMetaDataDone"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sync external metadata is done"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["syncExternalMetaDataDone"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/products-edit/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "or": {
    "id": 378,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["or"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["OR"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["or"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/products-edit/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "documentDeleted": {
    "id": 379,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["documentDeleted"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Document Deleted"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["documentDeleted"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/products-edit/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "productInformationCanNotBeDisplayedDueTogameType": {
    "id": 380,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["productInformationCanNotBeDisplayedDueTogameType"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Product information can not be displayed due to type"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["productInformationCanNotBeDisplayedDueTogameType"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/products-edit/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "insertAdditionalKeys": {
    "id": 381,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["insertAdditionalKeys"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Insert"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["insertAdditionalKeys"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/orders/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "extractInventory": {
    "id": 452,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["extractInventory"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Extract"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["extractInventory"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/stockpool-out/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "extractStockpool": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Extract keys from stockpool"])},
    "unassignedOption": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Extract unassigned keys"])},
    "allOption": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Extract all keys"])},
    "keysAvailable": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["keys available"])},
    "keysTotal": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["keys total"])},
    "submitButton": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Extract"])},
    "success": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Extraction request created. Keys will be delivered shortly."])},
    "failed": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Extraction failed."])},
    "noKeysToExtract": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No keys to extract."])}
  },
  "keepExistingMetaData": {
    "id": 382,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["keepExistingMetaData"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Keep Existing MetaData"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["keepExistingMetaData"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/products-edit/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "productSharingTableId": {
    "id": 383,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["productSharingTableId"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Product ID"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["productSharingTableId"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/products-edit/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "productSharingTableName": {
    "id": 384,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["productSharingTableName"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Product Name"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["productSharingTableName"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/products-edit/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "productSharingTableAll": {
    "id": 385,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["productSharingTableAll"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["All"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["productSharingTableAll"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/products-edit/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "productAssetsSaved": {
    "id": 386,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["productAssetsSaved"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Product Assets Saved"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["productAssetsSaved"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/products-edit/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "productAssetDeleted": {
    "id": 387,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["productAssetDeleted"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Product Asset Deleted"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["productAssetDeleted"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/products-edit/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "uploadDownloadPricing": {
    "id": 388,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["uploadDownloadPricing"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["UPLOAD/DOWNLOAD PRICING"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["uploadDownloadPricing"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/finance/price-lists-edit/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "typeOfAction": {
    "id": 389,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["typeOfAction"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Type of Action"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["typeOfAction"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/finance/price-lists-edit/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "priceType": {
    "id": 390,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["priceType"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Price Type"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["priceType"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/finance/price-lists-edit/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "pricing": {
    "id": 391,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["pricing"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["PRICING"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["pricing"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/finance/price-lists-edit/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "prices": {
    "id": 392,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["prices"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Prices"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["prices"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/finance/price-lists-edit/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "excelFileIsRequired": {
    "id": 393,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["prices"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Excel file is required"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["excelFileIsRequired"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/finance/price-lists-edit/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "allLanguages": {
    "id": 394,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["allLanguages"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["All Languages"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["allLanguages"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/finance/price-lists-edit/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "excelUploaded": {
    "id": 395,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["excelUploaded"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Excel file uploaded"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["excelUploaded"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/finance/price-lists-edit/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "mustBeExcelFile": {
    "id": 396,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["mustBeExcelFile"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Must be an excel file (.xls or .xlsx)"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["mustBeExcelFile"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/finance/price-lists-edit/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "somethingWentWrong": {
    "id": 397,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["somethingWentWrong"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Something went wrong"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["somethingWentWrong"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/401/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "redirectingToLogin": {
    "id": 398,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["redirectingToLogin"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Redirecting to sign in..."])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["redirectingToLogin"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/401/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "insertions": {
    "id": 399,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["insertions"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Insertions"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["insertions"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/distribution/myvault/uploads/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "insertionsDetail": {
    "id": 400,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["insertionsDetail"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Insertion Details"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["insertionsDetail"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/distribution/myvault/uploads/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "franchiseEnumTypeIdNotFound": {
    "id": 401,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["franchiseEnumTypeIdNotFound"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Could not find enumTypeId for Franchise attribute."])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["franchiseEnumTypeIdNotFound"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/products-add/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Error message for missing Franchise enumTypeId"])},
    "fuzzy": 0
  },
  "newFranchiseAdded": {
    "id": 402,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["newFranchiseAdded"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["New Franchise was added"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["newFranchiseAdded"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/products-add/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Success message for adding Franchise"])},
    "fuzzy": 0
  },
  "franchiseDeleted": {
    "id": 403,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["franchiseDeleted"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Franchise was deleted"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["franchiseDeleted"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/products-add/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Success message for deleting Franchise"])},
    "fuzzy": 0
  },
  "publisherEnumTypeIdNotFound": {
    "id": 404,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["publisherEnumTypeIdNotFound"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Could not find enumTypeId for Publisher attribute."])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["publisherEnumTypeIdNotFound"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/products-add/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Error message for missing Publisher enumTypeId"])},
    "fuzzy": 0
  },
  "newPublisherAdded": {
    "id": 405,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["newPublisherAdded"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["New Publisher was added"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["newPublisherAdded"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/products-add/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Success message for adding Publisher"])},
    "fuzzy": 0
  },
  "publisherDeleted": {
    "id": 406,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["publisherDeleted"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Publisher was deleted"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["publisherDeleted"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/products-add/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Success message for deleting Publisher"])},
    "fuzzy": 0
  },
  "developerEnumTypeIdNotFound": {
    "id": 407,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["developerEnumTypeIdNotFound"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Could not find enumTypeId for Developer attribute."])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["developerEnumTypeIdNotFound"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/products-add/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Error message for missing Developer enumTypeId"])},
    "fuzzy": 0
  },
  "newDeveloperAdded": {
    "id": 408,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["newDeveloperAdded"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["New Developer was added"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["newDeveloperAdded"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/products-add/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Success message for adding Developer"])},
    "fuzzy": 0
  },
  "developerDeleted": {
    "id": 409,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["developerDeleted"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Developer was deleted"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["developerDeleted"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/products-add/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Success message for deleting Developer"])},
    "fuzzy": 0
  },
  "uploadSuccessful": {
    "id": 410,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["uploadSuccessful"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Upload successful"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["uploadSuccessful"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/products-add/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "previewProduct": {
    "id": 411,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["previewProduct"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Preview Product"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["previewProduct"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/products-preview/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "preview": {
    "id": 412,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["preview"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Preview"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["preview"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/products-preview/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "fulfilmentDate": {
    "id": 413,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["fulfilmentDate"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fulfilment Date"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["fulfilmentDate"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/products-preview/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "screenshotsAndAssets": {
    "id": 414,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["screenshotsAndAssets"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Screenshots and Assets"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["screenshotsAndAssets"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/products-preview/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "back": {
    "id": 415,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["back"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Back"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["back"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/products-preview/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "preOrderDescription": {
    "id": 416,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["preOrderDescription"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pre-order Description"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["preOrderDescription"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/products-preview/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "systemRequirements": {
    "id": 417,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["systemRequirements"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["System Requirements"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["systemRequirements"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/products-preview/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "localizedName": {
    "id": 418,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["localizedName"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Localized Name"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["localizedName"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/products-preview/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "eula": {
    "id": 419,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["eula"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["EULA"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["eula"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/products-preview/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "website": {
    "id": 420,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["website"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Website"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["website"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/products-preview/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "socialMedia": {
    "id": 421,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["socialMedia"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Social Media"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["socialMedia"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/products-preview/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "productConfig": {
    "id": 422,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["productConfig"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Product Config"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["productConfig"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/products-preview/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "pricePreview": {
    "id": 423,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["pricePreview"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Price Preview"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["pricePreview"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/distribution/promotions/promotions-edit/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "noFilteredConnectionsFound": {
    "id": 424,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["noFilteredConnectionsFound"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No revoked keys found"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["noFilteredConnectionsFound"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/home/dashboard/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "productListIsEmpty": {
    "id": 425,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["productListIsEmpty"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Product list is empty"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["productListIsEmpty"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/home/dashboard/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "countryValueIsRequiredIfPriceTypeIsLocalPricing": {
    "id": 426,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["countryValueIsRequiredIfPriceTypeIsLocalPricing"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Country value is required if price type is local pricing"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["countryValueIsRequiredIfPriceTypeIsLocalPricing"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/home/dashboard/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "productsWithoutSKUs": {
    "id": 427,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["productsWithoutSKUs"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Products without SKUs"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["productsWithoutSKUs"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/home/dashboard/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "reportIsNotAvailable": {
    "id": 428,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["reportIsNotAvailable"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Report is not available"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["reportIsNotAvailable"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/home/dashboard/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "reportListWarning": {
    "id": 429,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["reportListWarning"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Report generation may take longer than usual. Your download will appear here once ready. Please avoid creating duplicate requests."])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["reportListWarning"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/home/dashboard/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "source": {
    "id": 430,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["source"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Source"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["source"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/home/dashboard/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "value": {
    "id": 431,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["value"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Value"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["value"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/home/dashboard/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "externalReference": {
    "id": 432,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["externalReference"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["External Reference"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["externalReference"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/home/dashboard/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "newReferenceType": {
    "id": 433,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["newReferrenceType"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["New Reference Type"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["newReferrenceType"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/account/external-references/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "addRegionWarningTitle": {
    "id": 434,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["addRegionWarning"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Important: Region Lock After Keys / Inventory Insertion"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["addRegionWarning"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/distribution/distributionsettings/regions-add/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "addRegionWarningText": {
    "id": 435,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["addRegionWarningText"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Once keys or inventory has been added to this region, the region configuration (countries) can no longer be edited. Please double-check your region setup before inserting keys or inventory."])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["addRegionWarningText"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/distribution/distributionsettings/regions-add/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "system": {
    "id": 436,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["system"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["System"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["system"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/account/external-references/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "enabled": {
    "id": 437,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["enabled"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Enabled"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["enabled"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/account/external-references/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "customRefererences": {
    "id": 438,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["customRefererences"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Custom References"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["customRefererences"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/account/external-references/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "public": {
    "id": 439,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["public"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Public"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["public"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/account/external-references/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "systemReferences": {
    "id": 440,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["systemRefererences"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["System References"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["systemRefererences"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/account/external-references/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "actions": {
    "id": 441,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["actions"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Actions"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["actions"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/account/external-references/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "externalRefNameTooltip": {
    "id": 442,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["externalRefNameTooltip"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["The name of the external reference, e.g. 'Oracle id'"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["externalRefNameTooltip"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/account/external-references/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "externalRefSourceTooltip": {
    "id": 443,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["externalRefSourceTooltip"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Describes where the external reference is coming from or used, e.g. 'Internal reporting'"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["externalRefSourceTooltip"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/account/external-references/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "externalRefOwnerTooltip": {
    "id": 444,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["externalRefOwnerTooltip"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Indicates whether the external reference is system-defined or user-defined."])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["externalRefOwnerTooltip"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/account/external-references/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "externalRefEnabledTooltip": {
    "id": 445,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["externalRefEnabledTooltip"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["This controls if your users will see the external reference option when editing external references on products & skus."])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["externalRefEnabledTooltip"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/account/external-references/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "externalRefPublicTooltip": {
    "id": 446,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["externalRefPublicTooltip"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["This controls if the external reference is shared with external partners or not."])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["externalRefPublicTooltip"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/account/external-references/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "imageContainer": {
    "icons": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Icons"])},
    "images": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Images"])},
    "more": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["more"])},
    "packshots": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Packshots"])}
  },
  "inbox": {
    "inbox": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Inbox"])},
    "outbox": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Outbox"])}
  },
  "inboxAssets": {
    "accept": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Accept"])},
    "acceptanceSmall": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Acceptance"])},
    "acceptInboxSuccesfull": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Accept Offer succesful"])},
    "acceptOffer": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ACCEPT OFFER"])},
    "allocation": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ALLOCATION"])},
    "confirmFinalAcceptance": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["I hereby accept this offer and understand that this is a permanent action and cannot be undone"])},
    "currentAvailableTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Current Available"])},
    "dateRowTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Date"])},
    "descriptionRowTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Description"])},
    "fencingRowTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fencing"])},
    "fromRowTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["From"])},
    "isAgreed": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Please note that this acceptance is final and cannot be undone"])},
    "maxQuantityTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Max Quantity"])},
    "maxStockTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Max Stock"])},
    "minBatchSizeTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Min. Batch Size"])},
    "NameRowTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Name"])},
    "offerSmall": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Offer"])},
    "offerTypeRowTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Offer type"])},
    "platformRowTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Platform (DRM)"])},
    "productNameRowTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Product name"])},
    "productSmall": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Product"])},
    "productTypeRowTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Product Type"])},
    "quantityRowTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Quantity"])},
    "regionsRowTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Region(s)"])},
    "reject": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Reject"])},
    "rejectInboxSuccesfull": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Reject Offer succesful"])},
    "rightSmall": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Right"])},
    "selectProduct": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Select Product"])},
    "validThroughRowTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Valid Dates"])},
    "regionRowTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Region"])},
    "transfer": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["TRANSFER"])},
    "estPrice": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Est. Price"])},
    "euro": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["€"])},
    "unitprice": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Unit Price"])}
  },
  "insertAssets": {
    "addMoreProducts": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Add more products"])},
    "addNewRights": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Add new rights"])},
    "assetsAreBeingAdded": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["INVENTORY IS BEING ADDED..."])},
    "cancel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cancel"])},
    "confirm": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confirm"])},
    "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Description"])},
    "descriptionForm": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Description"])},
    "emptyFile": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["File is empty."])},
    "error406": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Some or all uploaded keys already exist for this product, use the copy to clipboard button to get the details."])},
    "errorFile": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Error while reading the file."])},
    "extractionOptions": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Extraction"])},
    "fileName": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["File Name: "])},
    "fileRequired": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["File is required."])},
    "files": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Files: "])},
    "geoFencing": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Geo Fencing"])},
    "insert": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["INSERT"])},
    "insertAssets": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["INSERT INVENTORY"])},
    "insertSmall": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Insert"])},
    "keyNotUnique": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Keys are not unique."])},
    "mustBeTxtFiles": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Selected files must be .txt files"])},
    "name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Name"])},
    "next": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Next"])},
    "ok": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["OK"])},
    "platform": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Platform"])},
    "platformSummary": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Platform: "])},
    "previous": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Previous"])},
    "product": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Product"])},
    "productSummary": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Product: "])},
    "rights": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rights"])},
    "rightsSummary": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rights: "])},
    "sameKeyAtDifferentFiles": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["There are same key values in different txt files."])},
    "saveAsDraft": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Save as draft"])},
    "selectOrDropTxtFile": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Select or drop a .txt file with your product code"])},
    "selectTxtFile1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Select or drop .txt file with your product code"])},
    "selectExcelFile1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Select or drop .xls or .xlsx file"])},
    "selectTxtFile2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Make sure that the selected file meets the following requirements"])},
    "stockAdded": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["The stock batch of test Air agreements is currently being processed. You will being updated via your inbox when the batch is fully processed."])},
    "summary": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Summary"])},
    "summaryText1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["You'll get an update in your inbox when its fully processed."])},
    "summaryText2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([" In the mean while you can add extra units"])},
    "supportsBlackListing": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Blacklisting"])},
    "units": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Units: "])},
    "version": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Version"])},
    "versionSummary": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Version: "])},
    "visibility": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Visibility"])},
    "preOrderCount": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Preorder Count"])},
    "serialCount": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Serial Count"])},
    "reservationCount": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Reservation Count"])},
    "setPrice": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Set Price: "])},
    "choosenCurrency": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Choosen Currency: "])},
    "regionProductDetail": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Region: "])},
    "platformProductDetail": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Platform: "])},
    "skuProductDetail": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SKU: "])},
    "stockPoolSmall": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Stockpool"])},
    "stockPool": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["STOCKPOOL"])},
    "value": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Value"])},
    "of": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["of"])},
    "available": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["available"])},
    "selectConnection": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Select Connection"])},
    "maxStock": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Max Stock"])},
    "maxQuantity": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Max Quantity"])},
    "alertAt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Alert at"])},
    "addConnection": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Add Connection"])},
    "maxStockLimit": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Max. Stock(Limit): "])},
    "maxStockLimitText": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Maximal amount allowed stock limit in the Receivers vault, for this product/SKU, Stock amount should be lower than the Max. Stock(Limit) in order to receive new/more stock via this allocation."])},
    "maxTotalQuantity": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Max.(Total) Quantity: "])},
    "maxTotalQuantityText": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Is the maximum amount of stock for this connection."])},
    "createStockPool": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Create Stockpool"])},
    "warnPercentage": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Alert when below"])},
    "noStock": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["You have no stock for this product"])},
    "connectionOccurs": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Connection already selected"])},
    "stockPoolCreated": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["StockPool created"])},
    "enableDates": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Enable Date Selection"])}
  },
  "keyprovidersAdd": {
    "addNewKeyProvider": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Add new key provider"])}
  },
  "keyProvidersEdit": {
    "editEditKeyProvider": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Edit key provider"])}
  },
  "login": {
    "createAnAccount": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Create an account"])},
    "email": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Email"])},
    "forgotPassword": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Forgot Password?"])},
    "login": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Login"])},
    "password": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Password"])},
    "rePassword": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Re-enter Password"])},
    "screenResolutionText1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SCREEN RESOLUTION CURRENTLY NOT SUPORTED"])},
    "screenResolutionText2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["This version of VAULTN currently only supports desktop and laptop"])},
    "screenResolutionText3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["screen resolutions from 1280px and up."])},
    "signInSuccessful": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sign in successful"])},
    "signInUnSuccessful": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sign in unsuccessful"])},
    "signInWithYourEmail": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sign in with your email"])},
    "takeBackControlOfYourDigitalAssets": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Where the games industry transacts"])}
  },
  "authenticate": {
    "logInWithYourEmail": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Log in with your email"])},
    "youNeedtoAuthenticate": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["You need to authenticate!"])},
    "twoFactorAuthentication": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Two-Factor Authentication"])},
    "weNeedToKnowThisIsReallyYourVault": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["We need to know this is really your vault"])},
    "letsMakeSureItsReallyYou": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Let's Make Sure It's Really You"])},
    "code": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentication code"])},
    "code1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Code 01"])},
    "code2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Code 02"])},
    "next": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Next"])},
    "enter6DigitCode1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Please enter the 6-digit code from your two-factor authentication app."])},
    "enter6DigitCodeEmail": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Please enter the 6-digit code sent to your email."])},
    "useEmailConfirmation": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Use e-mail confirmation instead"])},
    "use2FAConfirmation": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Use two factor confirmation instead"])},
    "enterTheCodeDisplayedInAuthenticator": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Please enter code displayed in the authenticator"])},
    "authenticatorApp": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authenticator App"])},
    "email": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Email"])},
    "sendTwoFactorAuthenticationCode": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Send Two-Factor Authentication Code"])},
    "theCodeHasBeenSentViaemail": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["The code has been sent via email. You can request a new one after 50 seconds."])},
    "authenticationCodeInfo": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["To connect a two-factor authentication app to your Vaultn account, please first log in using email verification. Then, navigate to your account settings and follow the provided instructions to link the app to your account"])},
    "followUpLabelEmail1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["The code has been sent via email."])},
    "followUpLabelEmail2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["You can request a new one after"])},
    "followUpLabelEmail3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["seconds."])}
  },
  "mailTemplatesAdd": {
    "addNewMailTemplate": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Add new mail template"])}
  },
  "mailTemplatesEdit": {
    "editMailTemplate": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Edit mail template"])}
  },
  "markets": {
    "markets": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["MARKETS"])},
    "marketSettings": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["MARKET SETTINGS"])},
    "marketSettingsSmall": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Market Settings"])},
    "save": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Save"])},
    "regionManagementInfo": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activating and managing your Regions click on the 'Region Management' button"])}
  },
  "outboxAssets": {
    "allocation": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["TRANSFER"])},
    "blacklistingRowTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Blacklisting:"])},
    "dateRowTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Date:"])},
    "descriptionRowTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Description:"])},
    "extractionRowTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Extraction"])},
    "geoFencingRowTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Geo Fencing:"])},
    "nameRowTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Name:"])},
    "offer": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["OFFER"])},
    "platformRowTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Platform (DRM):"])},
    "quantityRowTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Quantity:"])},
    "relationShipRowTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Relationship:"])},
    "revoke": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Revoke"])},
    "revokeOutboxSuccesfull": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Revoke Offer Succesfull"])},
    "typeRowTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Type:"])},
    "vaultRowTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vault:"])},
    "visibilityRowTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Visibility"])}
  },
  "pageContent": {
    "cancel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cancel"])},
    "contentEdit": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Page Content Edit"])},
    "save": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Save"])}
  },
  "pageHeaders": {
    "account": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Account"])},
    "accountEdit": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Edit Account"])},
    "administration": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Administration"])},
    "agreementflowTransaction": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Agreementflow Transaction"])},
    "agreements": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rights"])},
    "allocated": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Allocated"])},
    "apiInsights": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["API Insights"])},
    "assets": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Inventory"])},
    "blacklistings": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Blacklistings"])},
    "certificates": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Certificates"])},
    "connections": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Connections"])},
    "countries": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Countries"])},
    "dashboard": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dashboard"])},
    "documentation": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Documentation"])},
    "exchangeRates": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Exchange Rates"])},
    "Finance": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Finance"])},
    "generalSettings": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["General Settings"])},
    "home": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Home"])},
    "inbox": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Inbox"])},
    "jitEndpoints": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["JIT Endpoints"])},
    "keyProviders": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Key Providers"])},
    "mailTemplates": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mail Templates"])},
    "markets": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Markets"])},
    "myAllocations": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["My Allocations"])},
    "myNetwork": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["My Network"])},
    "myVault": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["My Vault"])},
    "outbox": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Outbox"])},
    "pageContent": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Page Content"])},
    "platforms": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Platforms"])},
    "priceLists": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pricing"])},
    "productEditions": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Product Editions"])},
    "productFranchises": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Product Franchises"])},
    "products": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Products"])},
    "productTypes": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Product Types"])},
    "promised": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Allocated"])},
    "promises": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["My Allocations"])},
    "promotions": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Promotions"])},
    "regions": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Regions"])},
    "relationships": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Relationships"])},
    "reportList": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Reports"])},
    "settings": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Settings"])},
    "transactions": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Transactions"])},
    "users": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Users & Groups"])},
    "vaultnInvitations": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vaultn Invitations"])},
    "vaultnManagement": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vaultn Management"])},
    "webhooks": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Webhooks"])},
    "stockpool": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Stockpool"])},
    "uploads": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uploads"])},
    "orders": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Orders"])},
    "orderDetails": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Order Details"])},
    "sharing": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sharing"])},
    "insertions": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Insertions"])},
    "sharedSkus": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Shared SKUs"])},
    "transfers": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Transfers"])},
    "stockpools": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Stockpools"])},
    "distribution": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Distribution"])},
    "pricing": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pricing"])},
    "promotionsList": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Promotion"])},
    "distributionSettings": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Distribution Settings"])},
    "currencies": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Currencies"])},
    "productCatalog": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Product Catalog"])},
    "editProduct": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Edit Product"])},
    "catalogSharing": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Catalog Sharing"])},
    "network": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Network"])},
    "account&Help": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Account & Help"])},
    "developer": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Developer"])},
    "externalReferences": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["External References"])},
    "archivedUsers": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Archived Users"])}
  },
  "priceLists": {
    "addNewPriceList": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Add new pricing"])},
    "addPriceList": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Add Price List"])},
    "chooseXLXS": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Import Price List Excel"])},
    "editingInfoText": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["EDITING MODE: Currently you are editing this Price List. The changes you make can't be undone after SAVING this page."])},
    "editPriceList": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Edit Pricing"])},
    "priceListDetails": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Price List Details"])},
    "excelFieldsEmpty": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["productId, title, regionCode, CountryCode, currencyCode, amount fields can not be empty. Check excel file row: "])},
    "listAllProducts": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["List All Products"])},
    "showOnlyWithPrices": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Show Only With Prices"])},
    "productIdMustBeInteger": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["productId must be a whole number. Check excel file row: "])},
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Title"])},
    "connectionName": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Connection"])},
    "promotions": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Promotions"])},
    "type": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Type"])},
    "pricingType": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pricing Type"])},
    "sourceMargin": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Source Margin"])},
    "targetMargin": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Target Margin"])},
    "priceListAdded": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Price list added"])},
    "priceListCopied": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Price list copied"])},
    "priceListDeleted": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Price list deleted"])},
    "priceListSaved": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Price list saved"])},
    "priceListContinueSaving": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Price list continue saving. Please wait..."])},
    "priceListContinueSavingText1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Price list continue saving "])},
    "priceListContinueSavingText2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([". Please wait..."])},
    "importQueued": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Import queued. You will get an email when it is complete. This can take up to one hour."])},
    "importInProgress": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["An import is in progress for this price list. You cannot edit the prices until the import is complete. You will get an email when it is complete."])},
    "importCompleted": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["The price list import is complete."])},
    "importCompletedWithErrors": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["The price list import is complete, but ", _interpolate(_named("errorCount")), " rows were rejected. See the email for the error report."])},
    "importFailed": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["The price list import failed. See the email for more data."])},
    "ownerName": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Owner Name"])},
    "addProductPrice": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Add Product Price"])},
    "selectProduct": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Select Product"])},
    "region": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Region"])},
    "country": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Country"])},
    "currency": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Currency"])},
    "defaultCurrencySmall": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Default Currency"])},
    "srp": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SRP"])},
    "wsp": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["WSP"])},
    "fallBackPrice": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fallback price"])},
    "defaultPrice": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Default Price"])},
    "addProductPriceInfoText": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["You can add more countries and currencies to a region of any product."])},
    "priceListRegionAdded": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pricelist region added"])},
    "showAllCountries": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SHOW ALL COUNTRIES"])},
    "hideAllCountries": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["HIDE ALL COUNTRIES"])},
    "setaDefaultPrice": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SET A DEFAULT PRICE"])},
    "cannotBeSold": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cannot be sold to the following countries:"])},
    "chooseConnection": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Please select a connection to view/edit cost price"])},
    "selectDefaultCurrency": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["CURRENCY"])},
    "selectDefaultCurrencySmall": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Currency"])},
    "regionUpdated": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Region Updated"])},
    "regionDeleted": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Region Deleted"])},
    "defaultCurrency": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DEFAULT CURRENCY"])},
    "priceSRP": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["PRICE (SRP)"])},
    "costWSP": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["COST (WSP)"])},
    "vat": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["VAT"])},
    "defaultPriceUpper": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["APPLY TO ALL"])},
    "selectCountryToAdd": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Select Country"])},
    "save": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Save"])},
    "selectedCountriesAreAdded": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Selected country is added"])},
    "AddToAllCountries": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Add (to) all Countries"])},
    "priceListIsOwnedByYou": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["This Pricelist is Owned by you"])},
    "priceListIsSharedToYou": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["This PriceList is shared to you by "])},
    "edit": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Edit"])},
    "duplicatePricelist": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Duplicate Pricelist"])},
    "copyPriceList": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Copy Price List"])},
    "copyOf1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Copy of < "])},
    "copyOf2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([" >"])}
  },
  "setDefaultPrice": {
    "setDefaultPrice": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SET DEFAULT PRICE"])},
    "PriceLists": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Price Lists"])},
    "setDefaultPriceSmall": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Set Default Price"])},
    "selectCurrency": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Select Currency"])},
    "srp": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Price (SRP)"])},
    "wsp": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cost (WSP)"])},
    "cancel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cancel"])},
    "save": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Save"])}
  },
  "productEditionsAdd": {
    "addNewProductEdition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Add new product edition"])}
  },
  "productEditionsEdit": {
    "editProductEdition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Edit product edition"])}
  },
  "productFranchisesAdd": {
    "addNewProductFranchise": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Add new product franchise"])}
  },
  "productFranchisesEdit": {
    "editProductFranchise": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Edit product franchise"])}
  },
  "products": {
    "addProducts": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Add Products"])},
    "productAddSuccesfull": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Product add successful"])},
    "productAddUnSuccesfull": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Product add unsuccessful"])},
    "productConnectedStatusUpdated": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Product Connected Status Updated"])}
  },
  "productsAdd": {
    "addNewProduct": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Add a new product"])},
    "addRow": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Add Row"])},
    "cancel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cancel"])},
    "downloadPriceListExcel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Excel Upload/Download Pricing"])},
    "downloadPromotionsListExcel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Download Promotions List Excel"])},
    "editProduct": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Edit product"])},
    "id": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ID"])},
    "inputType": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Input type + field"])},
    "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Label"])},
    "metaData": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Metadata"])},
    "metaName": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Name"])},
    "metaValue": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Value"])},
    "platform": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Platform"])},
    "product": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Product"])},
    "productImage": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Product Image"])},
    "reportDuplicate": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Report Duplicate"])},
    "save": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Save"])},
    "stock": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Stock"])},
    "version": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Version"])},
    "developers": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Developers"])},
    "protectionSystems": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Protection Systems"])},
    "releaseDate": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Release Date"])},
    "serialReleaseDate": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Serial Release Date"])},
    "digitalReleaseDate": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Digital Release Date"])},
    "genres": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Genres"])},
    "spokenLanguages": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Spoken Languages"])},
    "subtitleLanguages": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Subtitle Languages"])},
    "menuLanguages": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Menu Languages"])},
    "whiteListCountries": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["White List Countries"])},
    "regionCodes": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Regions"])},
    "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Description"])},
    "instructions": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Instructions"])},
    "minimumRequirements": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Minimum Requirements"])},
    "recommendedRequirements": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Recommended Requirements"])},
    "availableForPreOrder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Available For Preorder"])},
    "productActivation": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Product Activation"])},
    "uploadImage": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Upload Image"])},
    "pleaseSelectAnImage": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Please select an image"])},
    "imageUploaded": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Image uploaded"])},
    "createRegion": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Create Region"])},
    "preview": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Preview"])},
    "syncExternalMetaData": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sync external meta-data"])}
  },
  "productTypes": {
    "addNewType": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ADD NEW TYPE"])},
    "editType": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["EDIT TYPE"])},
    "editTypeSmall": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Edit Type"])},
    "newType": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["New Type"])},
    "save": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Save"])}
  },
  "promiseAssets": {
    "assetsAreBeingTransferred": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ASSETS ARE BEING TRANSFERRED"])},
    "assetsSummary": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Assets: "])},
    "createPromise": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["CREATE ALLOCATION"])},
    "orderSummary": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Order: "])},
    "promise": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ALLOCATION"])},
    "quantity": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Quantity"])},
    "toSummary": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["To: "])},
    "transferSummary": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Transfer: "])},
    "unitPrice": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Unit price"])}
  },
  "promisedAssets": {
    "activate": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activate"])},
    "availableRowTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Available:"])},
    "expiresRowTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Expires:"])},
    "maxQuantityRowTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Max. Quantity:"])},
    "maxStockRowTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Max. Stock:"])},
    "minBatchRowTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Min. Batch:"])},
    "pause": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pause"])},
    "pausedRowTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Paused:"])},
    "platformRowTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Platform (DRM):"])},
    "productRowTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Product:"])},
    "promised": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["My Allocations"])},
    "promisedSmall": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["My Allocations"])},
    "promisedToMyVault": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["MY ALLOCATIONS"])},
    "relationShipRowTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Relationship:"])},
    "rightRowTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Right:"])},
    "startsRowTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Starts:"])}
  },
  "promisesAssets": {
    "activeRowTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Active:"])},
    "availableRowTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Available:"])},
    "expiresRowTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Expires:"])},
    "maxQuantityRowTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Max. Quantity:"])},
    "maxStockRowTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Max. Stock:"])},
    "minBatchRowTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Min. Batch:"])},
    "myPromise": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ALLOCATED"])},
    "myPromiseSmall": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Allocated"])},
    "pausedByRelationRowTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Paused By Relation:"])},
    "pausedRowTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Paused:"])},
    "platformRowTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Platform (DRM):"])},
    "productRowTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Product:"])},
    "promises": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Allocated"])},
    "relationShipRowTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Relationship:"])},
    "remoteStockRowTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Remote Stock:"])},
    "rightRowTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Right:"])},
    "startsRowTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Starts:"])}
  },
  "promotionFinance": {
    "editPromotion": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["EDIT PROMOTION"])},
    "promotions": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["PROMOTIONS"])},
    "promotionsSmall": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Promotions"])}
  },
  "promotions": {
    "addNewPromotion": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Add new Promotion"])},
    "addPromotion": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Add Promotion"])},
    "chooseXLXS": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Import Promotions List Excel"])},
    "discountFieldValidation": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Please enter a valid number in the Discount Field."])},
    "editPromotion": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Edit Promotion"])},
    "promotionDetails": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Promotion Details"])},
    "excelFieldsEmpty": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["id, promotionID, product title, sku, discount fields can not be empty. Check excel file row: "])},
    "idMustBeInteger": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["id must be integer. Check excel file row: "])},
    "promotionIDMustBeInteger": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["promotionID must be a whole number. Check excel file row: "])},
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Title"])},
    "validFrom": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Valid From"])},
    "validFromToCheck": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Valid To date must be greater than Valid From date"])},
    "validTo": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Valid To"])},
    "promotionAdded": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Promotion added"])},
    "promotionDeleted": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Promotion deleted"])},
    "deletePromotionItems": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Delete Promotion Items"])},
    "promotionItemsDeleted": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Promotion items deleted"])},
    "promotionSaved": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Promotion saved"])},
    "productSkusAreAddedAsPromotionItems": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Product SKUs are added as promotion items"])},
    "productSkusAreAddedAreGoingToBeAddedPromotionItems": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Product SKUs are going to be added as promotion items"])},
    "ownerName": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Owner Name"])},
    "linkedPriceList": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Linked Pricelist"])},
    "allDatesUTCFormat": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["All dates are formatted to UTC format, after SAVING"])},
    "changedDatesAreFormattedToUTC": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Changed dates are formatted to UTC format, after SAVING"])},
    "promotionIsOwnedByYou": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["This promotion is Owned by you"])},
    "promotionIsSharedToYou": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["This promotion is shared to you by "])},
    "selectSinglePromotionItem": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Select Single Promotion Item"])},
    "selectProducts": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Select Products"])},
    "AddSinglePromotionItem": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Add Single Promotion Item"])},
    "AddAllPromotionItem": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Add All Promotion Items"])},
    "PromotionItemAdded": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Promotion item added"])},
    "pleaseSelectPromotionItem": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Please select promotion item"])},
    "addPromotionItem": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Add Promotion Item"])},
    "allDatesUTCFormatInitialEntries": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Promotion start and end times are displayed in your local time zone and will be converted to UTC in our system. Please double-check your entries after saving to ensure accuracy."])},
    "allDatesUTCFormatInitialEntriesPromotionsTable": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Promotion start and end times are displayed in your local time zone."])},
    "duplicatePromotion": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Duplicate Promotion"])},
    "edit": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Edit"])},
    "copyPromotion": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Copy Promotion"])},
    "copyOf1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Copy of < "])},
    "copyOf2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([" >"])},
    "promotionCopied": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Promotion copied"])},
    "addAllProducts": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Add All Products"])},
    "addToPromotion": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Add To Promotion"])},
    "addAllSkus": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Add All SKUs"])},
    "sku": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SKU"])},
    "addItems": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Add Items"])},
    "pleaseSelectSkuFromListToAddPromotion": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Please select SKU from list to add promotion"])}
  },
  "relationships": {
    "acceptRelationship": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Accept Connection"])},
    "activate": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activate"])},
    "activateRelationship": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ACTIVATE CONNECTION"])},
    "activeSinceRowTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Active Since:"])},
    "addRelationship": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Invite New Connection"])},
    "cancelRelationship": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cancel Connection"])},
    "companyImage": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Company Image:"])},
    "companyRowTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Company:"])},
    "deleteRelationship": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Delete Connection"])},
    "removePricingType": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Remove Pricing Type"])},
    "emailAddressRowTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Contact email address:"])},
    "emailFromRowTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["email From:"])},
    "emailTo": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["email To"])},
    "fromRowTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["From:"])},
    "invite": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Invite"])},
    "invited": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Invited"])},
    "invitedRelationship": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["INVITED FOR CONNECTION"])},
    "inviteGUID": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Invite GUID"])},
    "inviteNewRelationship": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["INVITE NEW CONNECTION"])},
    "ownerEmailRowTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Owner email:"])},
    "ownerNameRowTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Owner Name:"])},
    "pending": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pending"])},
    "pendingRelationship": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["PENDING CONNECTION"])},
    "reInviteRelationship": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Re-invite Connection"])},
    "rejectRelationship": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Reject Connection"])},
    "relationGUID": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Relation GUID"])},
    "connectionGUID": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Connection GUID"])},
    "relationship": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Connection"])},
    "relationships": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Connections"])},
    "relationshipStatusRowTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Connection Status:"])},
    "saveRelationship": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Save Connection"])},
    "to": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["To"])},
    "vaultRowTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vault:"])},
    "selectionType": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Select Connection Type"])},
    "blacklistedCountries": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Blacklisted Countries"])},
    "restrictedCountries": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Restricted Countries"])},
    "defaultPricelist": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Default Pricelist"])},
    "catalogSharing": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Catalog Sharing"])},
    "emailToDialog": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Email To"])},
    "pricingModelTypes": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pricing Type"])},
    "sourceMargin": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Source Margin"])},
    "currency": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Currency"])},
    "invoicingCurrency": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Invoicing Currency"])},
    "targetMargin": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Target Margin"])},
    "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Message"])},
    "companyName": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Company Name"])},
    "emailAddress": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-mail Address"])},
    "connectionReInviteMessage": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Connection re-invitation successfully sent!"])},
    "connectionCancelMessage": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Connection canceled successfully."])},
    "connectionInviteMessage": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Connection invitation successfully sent!"])}
  },
  "actionConfirm": {
    "confirm": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confirm"])}
  },
  "reportDuplicate": {
    "report": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Report"])},
    "reportDuplicate": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["REPORT DUPLICATE"])},
    "reportDuplicateSmall": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Report Duplicate"])},
    "save": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Save"])}
  },
  "reports": {
    "scheduleSaved": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Schedule saved successfully"])},
    "confirmDeleteSchedule": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Are you sure you want to delete this schedule?"])},
    "availableReportTypes": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Available Report Types"])},
    "clientOrderReferences": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Client Order References"])},
    "createaReport": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Create a Report"])},
    "createReport": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["CREATE REPORT"])},
    "DateRange": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Date Range"])},
    "directionTypes": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Direction Types"])},
    "createdFrom": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Created from"])},
    "createdTo": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Created to"])},
    "downloadReport": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Download report"])},
    "downloadDisabledQueued": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Report is queued"])},
    "downloadDisabledProcessing": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Report is processing"])},
    "downloadDisabledError": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Report failed"])},
    "downloadDisabledNotReady": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Report is not ready"])},
    "endDate": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["End Date"])},
    "externalSkuReferences": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Publisher SKUs"])},
    "filtering": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Filtering"])},
    "finance": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Finance"])},
    "financeMode": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Finance Mode"])},
    "fulfilmentStatus": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fulfilment Status"])},
    "fulfilmentStatusFulfilled": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fulfilled"])},
    "fulfilmentStatusNotFulfilled": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Not Fulfilled"])},
    "fulfilmentStatusRequestedNotFulfilled": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Requested (Not Fulfilled)"])},
    "general": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["General"])},
    "all": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["All"])},
    "itemsSelected": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["items selected"])},
    "keyByKey": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Key By Key"])},
    "noReportsFound": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No reports found"])},
    "noSchedulesFound": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No schedules found"])},
    "reportTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Report title"])},
    "orderIds": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Order IDs"])},
    "platform": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Platform"])},
    "reports": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["REPORTS"])},
    "saleReturnType": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Type"])},
    "salesCountries": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sales Countries"])},
    "search": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Search"])},
    "selectReportType": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Report Type"])},
    "skus": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SKUs"])},
    "specificOrders": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Specific Orders"])},
    "specificOrdersRequireOrderIdsOrClientRefs": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Specific Orders requires at least one of: Order IDs or Client Order References."])},
    "startDate": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Start Date"])},
    "status": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Status"])},
    "statusError": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Error"])},
    "statusProcessing": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Processing"])},
    "statusQueued": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Queued"])},
    "statusReady": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ready"])},
    "statusUnknown": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Unknown"])},
    "titleRequired": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Title is required"])},
    "untitled": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Untitled"])},
    "validFromToCheck": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["End Date must be greater than Start date"])},
    "selectConnection": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Connections"])},
    "allConnections": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["All Connections"])},
    "connection": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Connection"])},
    "connections": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Connections"])},
    "connectionsCount": (ctx) => {const { normalize: _normalize, plural: _plural } = ctx;return _plural([_normalize(["Connection"]), _normalize(["Connections"])])},
    "productsCount": (ctx) => {const { normalize: _normalize, plural: _plural } = ctx;return _plural([_normalize(["Product"]), _normalize(["Products"])])},
    "product": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Product"])},
    "sku": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SKU"])},
    "country": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Country"])},
    "region": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Region"])},
    "financeT2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["T2 Finance"])},
    "revokedKeys": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Revoked Keys"])},
    "unsoldKeys": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Unsold Keys"])},
    "inventory": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Inventory Level"])},
    "inventoryWithStockLevels": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Inventory Report (Stock Levels)"])},
    "orderPayment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Order Payment"])},
    "providersCount": (ctx) => {const { normalize: _normalize, plural: _plural } = ctx;return _plural([_normalize(["SKU Provider"]), _normalize(["SKU Providers"])])},
    "regionsCount": (ctx) => {const { normalize: _normalize, plural: _plural } = ctx;return _plural([_normalize(["SKU Region"]), _normalize(["SKU Regions"])])},
    "filtersApplied": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Filters"])},
    "filtersCount": (ctx) => {const { normalize: _normalize, plural: _plural } = ctx;return _plural([_normalize(["Filter"]), _normalize(["Filters"])])},
    "filterConnections": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Connections"])},
    "filterProducts": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Products"])},
    "filterSku": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SKU"])},
    "filterExternalRef": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["External Ref"])},
    "filterTransactionType": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Transaction Type"])},
    "filterType": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Type"])},
    "filterFulfilmentStatus": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fulfilment Status"])},
    "filterPlatform": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Platform"])},
    "filterCountries": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Countries"])},
    "filterOrderIds": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Order IDs"])},
    "filterClientOrderRefs": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Client Order Refs"])},
    "filterRegions": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Regions"])},
    "transactionType": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Transaction Type"])},
    "transactionType1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Import"])},
    "transactionType2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Move"])},
    "transactionType3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Extraction"])},
    "transactionType4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Blacklist"])},
    "transactionType5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bulk Extraction"])},
    "transactionType6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Promise"])},
    "transactionType7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Just In Time"])},
    "transactionType8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Return"])},
    "transactionType9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Reservation"])},
    "transactionType10": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Revoke"])},
    "transactionType11": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pre Order"])},
    "transactionType12": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Back Order"])},
    "transactionType13": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Internal Extraction"])},
    "reportType": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Report Type"])},
    "createdDate": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Created Date"])},
    "products": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Products"])},
    "transactionTypeExtraction": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Extraction"])},
    "transactionTypeInsert": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Insert"])},
    "transactionTypeRevoke": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Revoke"])},
    "transactionTypeTransfer": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Transfer"])},
    "typeReturn": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Return"])},
    "typeSale": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sale"])},
    "enterMultipleSkusTooltip": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Enter multiple SKUs separated by commas, spaces, or line breaks"])},
    "scheduled": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Schedules"])},
    "scheduleFrequency": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Frequency"])},
    "createSchedule": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Create Schedule"])},
    "editSchedule": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Edit Schedule"])},
    "report": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Report"])},
    "nextRun": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Next Run"])},
    "lastRun": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Last Run"])},
    "isActive": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Active"])},
    "daily": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Daily"])},
    "everyNDays": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named, plural: _plural } = ctx;return _plural([_normalize(["Every day"]), _normalize(["Every ", _interpolate(_named("n")), " days"])])},
    "everyNWeekdays": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named, plural: _plural } = ctx;return _plural([_normalize(["Every weekday"]), _normalize(["Every ", _interpolate(_named("n")), " weekdays"])])},
    "weekly": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Weekly"])},
    "everyNWeeks": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named, plural: _plural } = ctx;return _plural([_normalize(["Every week"]), _normalize(["Every ", _interpolate(_named("n")), " weeks"])])},
    "monthly": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Monthly"])},
    "everyNMonths": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named, plural: _plural } = ctx;return _plural([_normalize(["Every month"]), _normalize(["Every ", _interpolate(_named("n")), " months"])])},
    "yearly": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Yearly"])},
    "everyNYears": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named, plural: _plural } = ctx;return _plural([_normalize(["Every year"]), _normalize(["Every ", _interpolate(_named("n")), " years"])])},
    "monday": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Monday"])},
    "tuesday": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tuesday"])},
    "wednesday": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wednesday"])},
    "thursday": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Thursday"])},
    "friday": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Friday"])},
    "saturday": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Saturday"])},
    "sunday": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sunday"])},
    "nWeeks": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named, plural: _plural } = ctx;return _plural([_normalize(["1 week"]), _normalize([_interpolate(_named("n")), " weeks"])])},
    "enterMultipleReferencesTooltip": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Enter multiple references separated by commas, spaces, or line breaks"])},
    "schedule": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Schedule"])},
    "scheduleName": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Schedule name"])},
    "period": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Reporting Period"])},
    "periodValue": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Period"])},
    "runOn": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Run on"])},
    "every": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Every"])},
    "onDays": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["On day(s)"])},
    "dayNumber": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Day #"])},
    "months": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Months"])},
    "dailyEveryDay": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Every day (Mon–Sun)"])},
    "dailyEveryWeekday": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Every weekday (Mon–Fri)"])},
    "dailyEveryNDays": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Every N days"])},
    "monthlyFirstWeekday": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["First weekday of the month"])},
    "monthlyLastWeekday": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Last weekday of the month"])},
    "monthlyFirstDay": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["First day of the month"])},
    "monthlyNthDay": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nth day of the month"])},
    "monthlyEveryNMonths": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Every N months"])},
    "periodPreviousDay": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Previous day"])},
    "periodPreviousWeek": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Previous week"])},
    "periodPreviousMonth": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Previous month"])},
    "periodPreviousNDays": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Previous N days"])},
    "periodPreviousNWeeks": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Previous N weeks"])},
    "periodPreviousNMonths": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Previous N months"])},
    "periodNDaysLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Days"])},
    "periodNWeeksLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Weeks"])},
    "periodNMonthsLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Months"])},
    "previewLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Preview"])},
    "previewTemplate": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Runs ", _interpolate(_named("cadence")), " from 4am to 5am UTC, covering ", _interpolate(_named("period")), "."])},
    "previewCadenceEveryDay": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["every day"])},
    "previewCadenceEveryWeekday": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["every weekday (Mon–Fri)"])},
    "previewCadenceEveryNDays": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["every ", _interpolate(_named("n")), " days"])},
    "previewCadenceWeeklyOn": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["every week on ", _interpolate(_named("days"))])},
    "previewCadenceWeeklyNOn": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["every ", _interpolate(_named("n")), " weeks on ", _interpolate(_named("days"))])},
    "previewCadenceFirstWeekday": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["on the first weekday of each month"])},
    "previewCadenceLastWeekday": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["on the last weekday of each month"])},
    "previewCadenceFirstDay": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["on the first day of each month"])},
    "previewCadenceNthDay": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["on day ", _interpolate(_named("n")), " of each month"])},
    "previewCadenceEveryNMonths": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["every ", _interpolate(_named("n")), " months"])},
    "previewPeriodPreviousDay": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["previous day"])},
    "previewPeriodPreviousWeek": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["previous week"])},
    "previewPeriodPreviousMonth": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["previous month"])},
    "previewPeriodPreviousNDays": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["previous ", _interpolate(_named("n")), " days"])},
    "previewPeriodPreviousNWeeks": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["previous ", _interpolate(_named("n")), " weeks"])},
    "previewPeriodPreviousNMonths": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["previous ", _interpolate(_named("n")), " months"])},
    "previewNoDays": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["no days selected"])},
    "startingFrom": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Starting from"])},
    "etlDelayWarningTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Reporting data delay"])},
    "etlDelayWarningBody": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sales and order data can currently be delayed by up to 4 hours. As a result, KBK and Finance reports that include today's data may be incomplete. We're working to reduce this delay to just a few minutes. Inventory and key extraction reports are not affected."])}
  },
  "resetPassword": {
    "instructions": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["please enter your email address below and we'll send you instructions on how to reset your password."])},
    "instructionsRegister1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Your password needs to be (re)applied."])},
    "instructionsRegister2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Apply a minimum of 8 characters in length which should contain one of every character type: Uppercase, lowercase, number & symbol."])},
    "instructionsRegister3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Your password must consider the following conditions"])},
    "mailSent": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Reset password instructions have been sent to the provided email address"])},
    "mailSentUnSuccessfull": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["We couldnt sent instructions to your email"])},
    "next": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Next"])},
    "resetMyPassword": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Reset my password"])},
    "returnToLogin": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Return to login"])},
    "saveAndLogin": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Save & Login"])},
    "8Characters": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["8 Characters"])},
    "ContainsNumber": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Contains Number"])},
    "ContainsUpperCase": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Contains UpperCase"])},
    "ContainsLowerCase": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Contains LowerCase"])},
    "ContainsSpecialCharacter": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Contains Special Character"])}
  },
  "sendTestEmail": {
    "sendTestEmail": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SEND TEST EMAIL"])},
    "sendTestEmailSmall": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Send Test email"])}
  },
  "setPassword": {
    "passwordCreated": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Account created successfuly. Please login with your new credentials."])},
    "passwordsMustBeSame": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Password & Re-enter Password don't match. Please check entered fields"])},
    "passwordValidation": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Password must be minimum of 8 characters in length which should contain one of every character type: Uppercase, lowercase, number & symbol."])}
  },
  "sharingRules": {
    "cancel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cancel"])},
    "save": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Save"])},
    "yes": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Yes"])},
    "no": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No"])}
  },
  "sku": {
    "all": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ALL"])},
    "cancel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cancel"])},
    "copied": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Copied"])},
    "copySKUs": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Copy SKUs"])},
    "ok": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["OK"])},
    "change": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Change"])},
    "back": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Back"])},
    "noPlatformsEnabled": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No platforms enabled. Go to"])},
    "settings": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Settings"])}
  },
  "summaryCard": {
    "stockPoolName": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["StockPool"])},
    "fileName": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Filename"])},
    "platform": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Platform"])},
    "price": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Price"])},
    "productName": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Product"])},
    "region": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Region"])},
    "relationShip": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Connection"])},
    "rights": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rights"])},
    "units": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([" Units"])}
  },
  "table": {
    "connect": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Connect"])},
    "disconnect": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Disconnect"])},
    "noSKU": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No SKU"])}
  },
  "tablePager": {
    "details": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Details"])},
    "edit": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Edit"])},
    "extractAssets": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Extract Inventory"])},
    "insertAssets": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Insert Inventory"])},
    "transferAssets": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Transfer Inventory"])},
    "editStockPool": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Edit StockPool"])},
    "editRegion": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Edit Region"])},
    "setAsFallBackPrice": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Set as Fallback Price"])},
    "setADefaultPrice": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Set a Default Price"])},
    "addCountry": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Add Country"])},
    "deleteRegion": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Delete Region"])},
    "view": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["View"])},
    "delete": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Delete"])}
  },
  "transactions": {
    "dateFrom": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Start Date"])},
    "dateTill": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["End Date"])},
    "publisher": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Publisher"])},
    "selectPeriod": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Select Period"])},
    "selectStartDateEndDate": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Please select Start Date & End Date"])}
  },
  "transferAssets": {
    "allocation": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Allocation"])},
    "asset": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Asset"])},
    "assetDetails": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Asset Details"])},
    "assetsSmall": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Assets"])},
    "cost": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cost: "])},
    "dates": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dates"])},
    "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Description"])},
    "extractionOptions": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Extraction"])},
    "geoFencing": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Geo Fencing"])},
    "inEuro": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["in EURO (€)"])},
    "maxQuantity": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Max Quantity"])},
    "maxStock": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Max Stock"])},
    "maxStockMustbebiggerThanMinBatch": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["The maximum stock must be bigger than minimum batch size"])},
    "minBatchSize": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Min. Batch Size"])},
    "name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Name"])},
    "network": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Network"])},
    "noDateSet": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No date set"])},
    "orderNo": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Order No"])},
    "orderNoCard": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Order No: "])},
    "orderNumber": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Order Number"])},
    "orderSmall": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Order"])},
    "orderSummary": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Order: "])},
    "platformSmall": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Platform (DRM)"])},
    "platformSummary": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Platform: "])},
    "productSmall": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Product"])},
    "productSummary": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Product: "])},
    "promotionalDates": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Promotional Dates"])},
    "regionCodeSmall": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Region"])},
    "relationShipSmall": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Connection"])},
    "relationshipSummary": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Relationship: "])},
    "rightsSmall": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rights"])},
    "rightsSummary": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rights: "])},
    "selectAssets": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Select Assets"])},
    "selectProducts": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Select Products"])},
    "selectRegion": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Region"])},
    "selectRelationship": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Select Connection"])},
    "selectRights": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Select Rights"])},
    "sell": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sell: "])},
    "st": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([" st."])},
    "startDate": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Start Date"])},
    "summarySmall": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Summary"])},
    "supportsBlackListing": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Blacklisting"])},
    "to": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["To"])},
    "toSummary": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["To: "])},
    "total": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Total: "])},
    "totalAssets": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Total Assets"])},
    "transfer": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["TRANSFER"])},
    "transferAssets": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["TRANSFER INVENTORY"])},
    "transferNewAssets": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Transfer new Assets"])},
    "transferring": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["TRANSFERRING..."])},
    "transferSmall": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Transfer"])},
    "transferStockSuccesfull": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Transfer Stock Succesfull"])},
    "transferSummary": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["You'll get an update in your inbox when it's fully processed. In the mean while you can transfer extra assets"])},
    "transferType": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Transfer Type"])},
    "transferTypeSmall": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Transfer Type"])},
    "unitPrice": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Unit price"])},
    "units": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Units"])},
    "unitsAndPricingSmall": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Units & Pricing"])},
    "unitSellPrice": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Unit sell price "])},
    "unitsSummary": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Units: "])},
    "untisAreBeingTransferred": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["UNITS ARE BEING TRANSFERRED"])},
    "validFrom": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["From"])},
    "validityForPromise": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Validity (For Allocation)"])},
    "validTo": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["To"])},
    "value": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Value"])},
    "valueCard": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Value: "])},
    "valueSummary": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Value: "])},
    "visibility": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Visibility"])},
    "priceList": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pricelist:"])},
    "unitPriceInfo": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Unit Price:"])},
    "estValue": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Est. Value:"])},
    "vaultNName": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vaultn Name:"])},
    "email": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-mail:"])},
    "companyName": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Company Name:"])},
    "productTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Title:"])},
    "skuSegment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SKU:"])},
    "validFromEstimated": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Valid From:"])},
    "validToEstimated": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Valid To:"])},
    "discount": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Discount: "])},
    "discountedValue": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Discounted Value: "])},
    "discountedTotalValue": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Discounted Total Value: "])}
  },
  "userEdit": {
    "account": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ACCOUNT"])},
    "cancel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cancel"])},
    "editUser": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["EDIT USER"])},
    "editUserSmall": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Edit User"])},
    "invite": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Invite"])},
    "newUser": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["NEW USER"])},
    "newUserSmall": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["User Information"])},
    "2FAAUthentication": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["2FA Authentication"])},
    "reSendInvite": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Resend Invite"])},
    "save": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Save"])},
    "saveAndInvite": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Save & Invite"])},
    "verify": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Verify"])},
    "name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Name"])},
    "email": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Email"])},
    "role": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Role"])},
    "receiveEmailNotifications": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Receive e-mail notifications"])},
    "active": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Active"])},
    "userInvited": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["User Invited"])}
  },
  "archiveUser": {
    "success": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["User archived successfully"])},
    "unarchive": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Unarchive"])},
    "unarchiveSuccess": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["User unarchived successfully"])},
    "mustBeInactive": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["User must be inactive before archiving"])}
  },
  "validationMessages": {
    "enterValidEmail": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Enter a valid email"])},
    "maxChars": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Check maximum characters"])},
    "maxValue": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Check maximum value"])},
    "minChars": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Check minimum characters"])},
    "minValue": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Check minimum value"])},
    "mustBeNumber": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Must be numeric"])},
    "mustBeString": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Must be string value"])},
    "requiredField": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Required Field"])},
    "mustBeBetween": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Must be between ", _interpolate(_named("fromLimit")), " and ", _interpolate(_named("toLimit"))])},
    "minArrayLength": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Select at least ", _interpolate(_named("limit"))])},
    "maxArrayLength": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Select at most ", _interpolate(_named("limit"))])},
    "mustBeWholeNumber": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Must be a whole number"])},
    "minValueIncluded": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Must be ", _interpolate(_named("limit")), " or greater"])}
  },
  "vaultnInvitations": {
    "invitationSent": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Invitation sent"])},
    "invite": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Invite"])},
    "inviteCompany": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Invite new company"])},
    "inviteNewCompany": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["INVITE NEW COMPANY"])}
  },
  "vaultnManagement": {
    "detail": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vaultn Management Detail"])}
  },
  "webhookAdd": {
    "activate": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activate"])},
    "check": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Check"])},
    "generateJWT": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Generate JWT"])},
    "newWebhookSmall": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["New Webhook"])},
    "PleaseEnterEndpointUrl": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Please enter endpoint URl"])},
    "webhookConfiguration": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["WEBHOOK CONFIGURATION"])}
  },
  "webhookEdit": {
    "account": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ACCOUNT"])},
    "activate": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activate"])},
    "check": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Check"])},
    "configureWebhookSmall": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Configure Webhook"])},
    "editWebhookSmall": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Edit Webhook"])},
    "generateJWT": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Generate JWT"])},
    "webhookConfiguration": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["WEBHOOK CONFIGURATION"])}
  },
  "widget": {
    "allocations": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Allocations"])},
    "bestAssets": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Best Assets"])},
    "canceled": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Canceled"])},
    "client": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Client"])},
    "finance": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Finance"])},
    "inOut": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["In / Out"])},
    "invoiced": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Invoiced"])},
    "lastWeek": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Last Week"])},
    "lowStock": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Low Stock"])},
    "margin": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Total Margin:"])},
    "more": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["more"])},
    "network": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Network"])},
    "onGoing": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ongoing"])},
    "orders": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Orders"])},
    "productCatalog": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Product Catalog"])},
    "promises": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Allocations:"])},
    "promisesIn": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Allocations IN"])},
    "promisesInOut": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Allocations In / Out"])},
    "promisesOut": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Allocations OUT"])},
    "revenueInOut": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Revenue IN / OUT"])},
    "stock": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Stock Value"])},
    "stockValueInOut": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Stock Value IN / OUT"])},
    "supplier": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Supplier"])},
    "tabIn": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["IN"])},
    "tabOut": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["OUT"])},
    "totalAssets": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["TOTAL ASSETS:"])},
    "totalMargin": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Total Margin"])},
    "totalStock": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["TOTAL STOCK"])},
    "totalUnits": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["TOTAL UNITS:"])},
    "transferIn": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Transfer IN"])},
    "transferOut": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Transfer OUT"])},
    "transfers": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Transfers"])},
    "units": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Units"])},
    "value": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["VALUE:"])},
    "quickLinks": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Quick Links"])},
    "myVault": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["My Vault"])},
    "myVaultText": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Manage your inventory and track transaction progress with ease."])},
    "financeText": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Take command of price lists, promotions, and generate tailored reports to suit your requirements."])},
    "myNetwork": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["My Network"])},
    "myNetworkText": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Expand your network by effortlessly adding new partners or efficiently manage your existing ones."])},
    "accountSettings": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Account Settings"])},
    "accountSettingsText": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Access to all settings relating to your Vaultn account."])}
  },
  "settings": {
    "updateOwnerRole": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Update Owner Role"])}
  },
  "platformSettings": {
    "noProvidersEnabledWarning": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SKU creation will not be possible unless at least one platform is enabled."])}
  },
  "JITEndPoints": {
    "allowBackOrder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Allow Back Order"])},
    "reservationExpiryTime": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Reservation Expiry Time"])}
  },
  "stockPool": {
    "stockPool": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["STOCKPOOL"])},
    "stockPoolSmall": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["StockPool"])},
    "editStockPool": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["EDIT STOCKPOOL"])},
    "selectStockPool": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Select StockPool"])},
    "selectStockPoolSmall": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Select StockPool"])},
    "editStockPoolSmall": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Edit StockPool"])},
    "stockPoolSaved": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["StockPool saved"])},
    "partialAllocationTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["StockPool partially updated"])},
    "partialAllocationError": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Some connections were updated before the save failed."])},
    "uncertainAllocationTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["StockPool update could not be confirmed"])},
    "uncertainAllocationError": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["The save failed, but some changes may have been applied."])},
    "updatedConnections": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Connections already updated:"])},
    "refreshAfterFailedSave": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Close this message to refresh the list, then reopen the StockPool before retrying. Unsaved form changes will be discarded."])},
    "closeAndRefresh": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Close and refresh"])},
    "allocationNotWhole": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Allocation must be a whole number of keys."])},
    "allocationShortfall": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["The pool could not supply every key: ", _interpolate(_named("secured")), " of ", _interpolate(_named("requested")), " reserved across ", _interpolate(_named("count")), " connection(s). The rest will be reserved as keys arrive."])},
    "allocationBelowExtracted": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Allocation cannot be below ", _interpolate(_named("extracted")), " extracted keys."])},
    "allocationAboveMaximum": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Allocation cannot be above ", _interpolate(_named("maximum")), " keys after other connection allocations."])},
    "fromToCheck": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["To date must be greater than From date"])},
    "pool#": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pool#"])},
    "connections": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Connections:"])},
    "dates": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dates:"])},
    "totalStock": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Total Stock:"])},
    "restStock": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Available Stock:"])},
    "product": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Product:"])},
    "platform": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Platform:"])},
    "region": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Region:"])},
    "right": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Right:"])},
    "na": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["NA"])}
  },
  "regions": {
    "addRegion": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Add Region"])},
    "showActiveRegions": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Show Active Regions"])},
    "showAllSystemRegions": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Show All Regions"])},
    "showExcludedRegions": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Show Excluded Regions"])},
    "searchProduct": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Search Product"])},
    "notAllowedToEditSystemRegion": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["You are not allowed to update SYSTEM REGION"])},
    "notAllowedToEditActiveRegion": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["You are not allowed to update ACTIVE/IN USE REGION"])},
    "regionCodes": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Regions"])},
    "regionManagement": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Region Management"])},
    "notTheOwner": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["You are not the owner of this region"])}
  },
  "regionsAdd": {
    "addNewRegion": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Add New Region"])},
    "regionName": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Region Name"])},
    "regionTemplate": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Region template"])},
    "addCountries": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Add Countries"])},
    "shortCode": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Short Code"])},
    "infoText1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["This region will be part of your custom regions."])},
    "infoText2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["This is a copy of"])},
    "createACopy": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Create a copy"])},
    "currency": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Currency"])},
    "warning": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Region Name, Short Code can not be empty."])},
    "active": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Active"])},
    "excluded": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Excluded"])},
    "regionCreated": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Region created"])},
    "generate": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Generate"])},
    "enterRegionName": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Enter Region Name"])},
    "createRegionCode": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Create Region"])},
    "unsavedChangesWarning": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["You will lose all entered data related to the Regions!"])},
    "attention": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Attention"])}
  },
  "regionsEdit": {
    "editRegion": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Edit Region"])},
    "regionCountries": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Region Countries"])},
    "regionUpdated": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Region Updated"])},
    "infoText1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["This is a Default System Region"])},
    "infoText2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["This is a copy of"])},
    "infoText3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["This region is ACTIVE in use and cannot be deleted"])},
    "infoText4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["You are not the owner of this region"])},
    "infoText5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["RESTRICTED: Cannot be activated in the following countries:"])},
    "regionDeleted": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Region deleted"])},
    "regionWillBeDeleted": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Region will be deleted. Are you sure?"])},
    "delete": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Delete"])},
    "regionCopied": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Region Copied"])},
    "copyRegion": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Copy Region"])},
    "viewRegion": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["View Region"])}
  },
  "skuSegment": {
    "id": 447,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["skuSegment"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SKU Segment"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["skuSegment"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/settings/account/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "claimSkuSegment": {
    "id": 448,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["claimSkuSegment"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Claim"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["claimSkuSegment"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/settings/account/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "skuSegmentExample": {
    "id": 450,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["skuSegmentExample"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Your SKUs will look like:"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["skuSegmentExample"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/settings/account/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "skuSegmentLengthRule": {
    "id": 451,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["skuSegmentLengthRule"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Must be 4 characters (A–Z, 0–9)"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["skuSegmentLengthRule"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/settings/account/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "skuSegmentSuccess": {
    "id": 449,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["skuSegmentSuccess"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SKU Segment claimed successfully"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["skuSegmentSuccess"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/settings/account/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "defaultAlertLevel": {
    "id": 507,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["defaultAlertLevel"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Default alert level"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["defaultAlertLevel"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/distribution/myvault/inventory/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "alertLevel": {
    "id": 508,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["alertLevel"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Alert level"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["alertLevel"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/distribution/myvault/inventory/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "networkAlertDefaultInfo": {
    "id": 509,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["networkAlertDefaultInfo"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Default level for low stock alerts. Stockpool alerts are separate."])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["networkAlertDefaultInfo"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/distribution/myvault/inventory/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "networkAlertColumnInfo": {
    "id": 510,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["networkAlertColumnInfo"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Level for low stock alerts. Overrides the default value above."])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["networkAlertColumnInfo"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/distribution/myvault/inventory/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "syncSelectCategories": {
    "id": 511,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["syncSelectCategories"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Select what to import"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["syncSelectCategories"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/products-edit/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "syncGeneralInformation": {
    "id": 512,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["syncGeneralInformation"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["General information"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["syncGeneralInformation"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/products-edit/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "syncAgeRatings": {
    "id": 513,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["syncAgeRatings"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Age ratings"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["syncAgeRatings"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/products-edit/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "syncLegalLines": {
    "id": 514,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["syncLegalLines"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Legal lines"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["syncLegalLines"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/products-edit/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "syncRightsDisclaimer": {
    "id": 515,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["syncRightsDisclaimer"])},
    "definition": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["By syncing, you instruct VaultN to retrieve the selected content and confirm the necessary rights to that content and its retrieval. ", _interpolate(_named("terms")), " apply."])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["syncRightsDisclaimer"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/products-edit/"])},
    "comment": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("terms")), " becomes the syncTermsLink link. Move it, do not remove it."])},
    "fuzzy": 0
  },
  "syncTermsLink": {
    "id": 542,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["syncTermsLink"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["T&Cs"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["syncTermsLink"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/products-edit/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Link text inside syncRightsDisclaimer."])},
    "fuzzy": 0
  },
  "syncTermsUrl": {
    "id": 543,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["syncTermsUrl"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["https://vaultn.com/vaultn-terms-conditions/#product-information-terms-of-service"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["syncTermsUrl"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/products-edit/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Terms and Conditions page for this locale."])},
    "fuzzy": 0
  },
  "packshot": {
    "id": 517,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["packshot"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Packshot"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["packshot"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/products-edit/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "heroImage": {
    "id": 518,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["heroImage"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hero image"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["heroImage"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/products-edit/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "logo": {
    "id": 519,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["logo"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Logo"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["logo"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/products-edit/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "trailers": {
    "id": 520,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["trailers"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Trailers"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["trailers"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/products-edit/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "alreadyImported": {
    "id": 521,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["alreadyImported"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Already imported"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["alreadyImported"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/products-edit/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "importMedia": {
    "id": 522,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["importMedia"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Import media"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["importMedia"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/products-edit/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "noExternalMedia": {
    "id": 523,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["noExternalMedia"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["This app has no media to import"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["noExternalMedia"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/products-edit/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "mediaImported": {
    "id": 524,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["mediaImported"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Media imported"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["mediaImported"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/products-edit/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "mediaImportFailed": {
    "id": 525,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["mediaImportFailed"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Some media could not be imported"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["mediaImportFailed"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/products-edit/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "syncStepPlatformId": {
    "id": 526,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["syncStepPlatformId"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Platform ID"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["syncStepPlatformId"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/products-edit/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "syncStepMedia": {
    "id": 527,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["syncStepMedia"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Media"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["syncStepMedia"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/products-edit/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "syncDialogTitle": {
    "id": 530,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["syncDialogTitle"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["META-DATA"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["syncDialogTitle"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/products-edit/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "syncAction": {
    "id": 531,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["syncAction"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sync"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["syncAction"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/products-edit/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "syncStepSummary": {
    "id": 532,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["syncStepSummary"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Summary"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["syncStepSummary"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/products-edit/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "syncSummaryGeneral": {
    "id": 534,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["syncSummaryGeneral"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["General information values"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["syncSummaryGeneral"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/products-edit/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "syncSummaryAgeRatings": {
    "id": 535,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["syncSummaryAgeRatings"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Age rating boards"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["syncSummaryAgeRatings"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/products-edit/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "syncSummaryLegalLines": {
    "id": 536,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["syncSummaryLegalLines"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Legal line values"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["syncSummaryLegalLines"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/products-edit/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "syncSummaryMediaImported": {
    "id": 537,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["syncSummaryMediaImported"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Media imported"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["syncSummaryMediaImported"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/products-edit/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "syncSummaryMediaFailed": {
    "id": 538,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["syncSummaryMediaFailed"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Media failed"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["syncSummaryMediaFailed"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/products-edit/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "syncSummaryNote": {
    "id": 539,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["syncSummaryNote"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["The values are in the product form. Please review them before saving the product."])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["syncSummaryNote"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/products-edit/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "reviewAction": {
    "id": 540,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["reviewAction"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Review"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["reviewAction"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/products-edit/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  },
  "openLink": {
    "id": 541,
    "term": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["openLink"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Open the link in a new tab"])},
    "context": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["openLink"])},
    "term_plural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["/my_vault/products-edit/"])},
    "comment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "fuzzy": 0
  }
}